<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <ClientNav v-if="$route.query.clientNav !== 'false'"/>
        <v-row dense>
            <v-col cols="12">
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-form
                            ref="form"
                            lazy-validation>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <span>Is this related to a Support Strategy?</span>
                                        <v-row>
                                            <v-col cols="12" sm="2">
                                                <v-radio-group v-model="supportStrategy">
                                                    <v-radio label="Yes" value="Yes"></v-radio>
                                                    <v-radio label="No" value="No"></v-radio>
                                                </v-radio-group>
                                            </v-col>

                                            <v-col cols="12" sm="8" v-if="supportStrategy === 'Yes'">
                                                <v-select
                                                    label="Select Support Strategy"
                                                    :items="strategies"
                                                    item-text="Goal"
                                                    item-value="_id"
                                                    v-model="strategy"
                                                    return-object
                                                ></v-select>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12">
                                        <span>Is this related to a Human Rights Restriction?</span>
                                        <v-row>
                                            <v-col cols="12" sm="2">
                                                <v-radio-group :rules='requiredField'
                                                               v-model="humanRights">
                                                    <v-radio label="Yes" value="Yes"></v-radio>
                                                    <v-radio label="No" value="No"></v-radio>
                                                </v-radio-group>
                                            </v-col>


                                            <v-col cols="12" sm="8" v-if="humanRights === 'Yes'">
                                                <v-select
                                                    label="Select Human Rights"
                                                    :items="rights"
                                                    item-text="Restriction"
                                                    item-value="_id"
                                                    v-model="restriction"
                                                ></v-select>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                        <v-select
                                            v-model="newType"
                                            label="Incident Category"
                                            :items="category"
                                            :rules='requiredField'
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="4">
                                        <v-menu
                                            offset-y
                                            min-width="290px"
                                            max-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-datetime-picker
                                                    v-model="newIncidentDateTime"
                                                    label="Incident Date and Approximate Time"
                                                    prepend-icon="events"
                                                    v-on="on"
                                                    :rules="requiredField"
                                                ></v-datetime-picker>
                                            </template>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="4">
                                        <v-menu
                                            ref="calendar2Menu"
                                            v-model="calendar2Menu"
                                            :close-on-content-click="false"
                                            :return-value.sync="date"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="newTodaysDate"
                                                    label="Today's Date"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :rules='requiredField'
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="newTodaysDate"
                                                no-title
                                                scrollable
                                                :rules='requiredField'

                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="calendar2Menu = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="$refs.calendar2Menu.save(date)"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <v-menu
                                            offset-y
                                            min-width="290px"
                                            max-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-datetime-picker
                                                    v-model="newIncidentDiscovered"
                                                    label="Incident Discovered Date and Time"
                                                    prepend-icon="events"
                                                    v-on="on"
                                                    :rule="requiredField"
                                                ></v-datetime-picker>
                                            </template>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <v-select
                                            label="Program"
                                            v-model="newProgram"
                                            :items="units"
                                            item-text="Name"
                                            item-value="Name"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" class="white--text text-uppercase text-center"
                                           style="background-color: #2b3990; border-radius: 10px">
                                        Incident Location
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field
                                            v-model="newIncidentLocation"
                                            label="Incident Location"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field
                                            v-model="newStreet"
                                            label="Street"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field
                                            v-model="newCity"
                                            label="City"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field
                                            v-model="newState"
                                            label="State"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field
                                            v-model="newZipCode"
                                            label="Zip Code"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-select
                                            v-model="newIncidentLocationType"
                                            label="Incident Location Type"
                                            :items="location"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" class="white--text text-uppercase text-center"
                                           style="background-color: #2b3990; border-radius: 10px">
                                        People Involved
                                    </v-col>


                                    <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                                        <v-text-field
                                            v-model="newPersonInvolved1"
                                            label="Name of Person Involved"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                                        <v-text-field
                                            v-model="newTitle1"
                                            label="Title"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                                        <v-text-field
                                            v-model="newPhone1"
                                            label="Phone Number"
                                            v-mask="'(###) ###-####'"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12" md="4">
                                        <v-select
                                            v-model="newRoles1"
                                            label="Persons Role"
                                            :items="roles"
                                        ></v-select>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12" md="4">
                                        <v-select
                                            v-model="newInvolvement1"
                                            label="Persons Involvement Role"
                                            :items="involvement"
                                        ></v-select>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12" md="4">
                                        <v-btn @click="person2='true'">Add Another Person</v-btn>
                                    </v-col>


                                    <!-- end of person 1 -->
                                    <div v-if="person2">
                                        <v-row>
                                            <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                                                <v-text-field
                                                    v-model="newPersonInvolved2"
                                                    label="Name of Person Involved"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                                                <v-text-field
                                                    v-model="newTitle2"
                                                    label="Title"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                                                <v-text-field
                                                    v-model="newPhone2"
                                                    label="Phone Number"
                                                    v-mask="'(###) ###-####'"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12" md="4">
                                                <v-select
                                                    v-model="newRoles2"
                                                    label="Persons Role"
                                                    :items="roles"
                                                ></v-select>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12" md="4">
                                                <v-select
                                                    v-model="newInvolvement2"
                                                    label="Persons Involvement Role"
                                                    :items="involvement"
                                                ></v-select>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12" md="4">
                                                <v-btn @click="person3='true'">Add Another Person
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <!-- end of person 2 -->

                                    <div v-if="person3">
                                        <v-row>
                                            <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                                                <v-text-field
                                                    v-model="newPersonInvolved3"
                                                    label="Name of Person Involved"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                                                <v-text-field
                                                    v-model="newTitle3"
                                                    label="Title"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col class="d-flex mt-10" cols="12" sm="12" md="4">
                                                <v-text-field
                                                    v-model="newPhone3"
                                                    label="Phone Number"
                                                    v-mask="'(###) ###-####'"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12" md="4">
                                                <v-select
                                                    v-model="newRoles3"
                                                    label="Persons Role"
                                                    :items="roles"
                                                ></v-select>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12" md="4">
                                                <v-select
                                                    v-model="newInvolvement3"
                                                    label="Persons Involvement Role"
                                                    :items="involvement"
                                                ></v-select>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12"></v-col>
                                        </v-row>
                                    </div>
                                    <!-- end of person 3 -->


                                    <v-col cols="12" class="white--text text-uppercase text-center"
                                           style="background-color: #2b3990; border-radius: 10px">
                                        Parties Notified
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field
                                            v-model="newOrganization1"
                                            label="Organization"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field
                                            v-model="newOrgPhone1"
                                            label="Phone"
                                            v-mask="'(###) ###-####'"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-select
                                            v-model="newOrgType1"
                                            label="Organization"
                                            :items="organization"
                                        ></v-select>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field
                                            v-model="newOrgFullName1"
                                            label="Full Name"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field
                                            v-model="newOrgTitle1"
                                            label="Title"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <v-menu
                                            offset-y
                                            min-width="290px"
                                            max-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    :value="newOrgNotDate1"
                                                    label="Notification Date"
                                                    v-on="on"
                                                    prepend-icon="events"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="newOrgNotDate1"
                                                           scrollable></v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field
                                            v-model="newOrgCaseNum1"
                                            label="Case Number"
                                        ></v-text-field>
                                    </v-col>


                                    <v-col cols="12" class="white--text text-uppercase text-center"
                                           style="background-color: #2b3990; border-radius: 10px">
                                        Incident Involved (Select All That Apply)
                                    </v-col>


                                    <v-col cols="12" sm="6">
                                        <span class="font-weight-bold">Incident Involved</span>

                                        <v-checkbox v-model="hospital" label="Hospital Admission"
                                                    value="Hospital Admission"></v-checkbox>
                                        <div v-if="hospital" class="grey lighten-3 pa-5 ml-5">
                                            <v-text-field v-model="newHospitalName"
                                                          label="Hospital Name"></v-text-field>
                                            <v-datetime-picker v-model="newHospitalDate"
                                                               label="Admission Date"></v-datetime-picker>
                                            <div class="mt-5 text-uppercase">Facility Type</div>
                                            <v-item-group>
                                                <v-switch v-model="newFacilityType" label="Hospital"
                                                          value="Hospital"></v-switch>
                                                <v-switch v-model="newFacilityType"
                                                          label="Psychiatric Unit/Facility"
                                                          value="Psychiatric Unit/Facility"></v-switch>
                                                <v-switch v-model="newFacilityType"
                                                          label="Other (describe)"
                                                          value="Other (describe)"></v-switch>
                                            </v-item-group>
                                            <v-text-field
                                                v-if="newFacilityType == 'Other (describe)'"
                                                label="Other details"
                                                v-model="newOtherHospital"></v-text-field>
                                        </div>

                                        <v-checkbox v-model="lawEnforcement" label="Law Enforcement"
                                                    value="Law Enforcement"></v-checkbox>
                                        <div v-if="lawEnforcement" class="grey lighten-3 pa-5 ml-5">
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <v-switch v-model="newLaw"
                                                                  label="Charges Filed"
                                                                  value="Charges Filed"></v-switch>
                                                        <v-switch v-model="newLaw"
                                                                  label="Citation Issued"
                                                                  value="Citation Issued"></v-switch>
                                                        <v-switch v-model="newLaw"
                                                                  label="Client Arrested"
                                                                  value="Client Arrested"></v-switch>

                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <v-switch v-model="newLaw"
                                                                  label="Client Taken to Jail"
                                                                  value="Client Taken to Jail"></v-switch>
                                                        <v-switch v-model="newLaw"
                                                                  label="Police Called"
                                                                  value="Police Called"></v-switch>
                                                        <v-switch v-model="newLaw"
                                                                  label="Police Talked to Client"
                                                                  value="Police Talked to Client"></v-switch>
                                                        <v-switch v-model="newLaw"
                                                                  label="Other (describe)"
                                                                  value="Other (describe)"></v-switch>
                                                    </v-col>

                                                    <v-col cols="12" sm="12">
                                                        <v-text-field
                                                            v-if="newLaw == 'Other (describe)'"
                                                            label="Other details"
                                                            v-model="newLawOther"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-container>

                                            <!-- <v-text-field v-if="otherLaw" label="Other details" v-model="newOtherLaw"></v-text-field> -->
                                        </div>

                                        <v-checkbox v-model="medicalCare" label="Medical Care"
                                                    value="Medical Care"></v-checkbox>
                                        <div v-if="medicalCare" class="grey lighten-3 pa-5 ml-5">
                                            <v-container>
                                                <span>Select all that apply</span>
                                                <v-row>
                                                    <v-col cols="12" sm="6">
                                                        <v-switch v-model="new911Call"
                                                                  label="911 Called"
                                                                  value="911 Called"></v-switch>
                                                        <v-switch v-model="newMedicalClinic"
                                                                  label="Client Taken to Medical Clinic"
                                                                  value="Client Taken to Medical Clinic"></v-switch>
                                                        <v-switch v-model="newER"
                                                                  label="Client Taken to ER"
                                                                  value="Client Taken to ER"></v-switch>
                                                        <v-switch v-model="newAssessedClient"
                                                                  label="Crisis Staff Assessed Client"
                                                                  value="Crisis Staff Assessed Client"></v-switch>
                                                    </v-col>
                                                    <v-col cols="12" sm="6">
                                                        <v-switch v-model="newFirstAid"
                                                                  label="First Aid Adiministered"
                                                                  value="First Aid Adiministered"></v-switch>
                                                        <v-switch v-model="newPoison"
                                                                  label="Poison Control Contacted"
                                                                  value="Poison Control Contacted"></v-switch>
                                                        <v-switch v-model="newNurseContacted"
                                                                  label="Provider Nurse Contacted"
                                                                  value="Provider Nurse Contacted"></v-switch>
                                                        <v-switch label="Other (describe)"
                                                                  v-model="otherMedical"
                                                                  value="Other (describe)"></v-switch>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                            <v-text-field v-if="otherMedical == 'Other (describe)'"
                                                          label="Other details"
                                                          v-model="newOtherMedical"></v-text-field>
                                        </div>
                                    </v-col>


                                    <v-col cols="12" class="white--text text-uppercase text-center"
                                           style="background-color: #2b3990; border-radius: 10px">
                                        Incident Category (Select All That Apply)
                                    </v-col>

                                    <v-row>


                                        <v-col cols="12" sm="12">
                                            <v-select multiple :items="incidentCategory"
                                                      label="Select all that apply"
                                                      v-model="newIncidentCategory"></v-select>
                                        </v-col>
                                        <v-col cols="12">
                                            <div
                                                v-if="newIncidentCategory.includes('Abuse/Neglect/Exploitation')">
                                                <v-row>
                                                    <v-col cols="12" sm="3"
                                                           class="grey lighten-4 pa-5 ma-2">

                                                        <h2>Abuse Category</h2>
                                                        <v-switch v-model="newAbuseCategory"
                                                                  label="Emotional"
                                                                  value="Emotional"></v-switch>
                                                        <v-switch v-model="newAbuseCategory"
                                                                  label="Financial"
                                                                  value="Financial"></v-switch>
                                                        <v-switch v-model="newAbuseCategory"
                                                                  label="Physical"
                                                                  value="Physical"></v-switch>
                                                        <v-switch v-model="newAbuseCategory"
                                                                  label="Exploitation"
                                                                  value="Exploitation"></v-switch>
                                                        <v-switch v-model="newAbuseCategory"
                                                                  label="Neglect"
                                                                  value="Neglect"></v-switch>
                                                        <v-switch v-model="newAbuseCategory"
                                                                  label="Sexual"
                                                                  value="Sexual"></v-switch>

                                                    </v-col>
                                                    <v-col cols="12" sm="2"
                                                           class="grey lighten-4 pa-5 ma-2">

                                                        <h2>Abuse Type</h2>
                                                        <v-switch v-model="newAbuseType"
                                                                  label="Observed"
                                                                  value="Observed"></v-switch>
                                                        <v-switch v-model="newAbuseType"
                                                                  label="Suspected"
                                                                  value="Suspected"></v-switch>

                                                    </v-col>
                                                    <v-col cols="12" sm="3"
                                                           class="grey lighten-4 pa-5 ma-2">

                                                        <h2>Client Role in Abuse</h2>
                                                        <v-switch v-model="newClientRole"
                                                                  label="Perpetrator"
                                                                  value="Perpetrator"></v-switch>
                                                        <v-switch v-model="newClientRole"
                                                                  label="Victim"
                                                                  value="Victim"></v-switch>
                                                        <v-switch v-model="newClientRole"
                                                                  label="Perpetrator and Victim"
                                                                  value="Perpetrator and Victim"></v-switch>

                                                    </v-col>
                                                    <v-col cols="12" sm="3"
                                                           class="grey lighten-4 pa-5 ma-2">

                                                        <h2>Protective Services Notified</h2>
                                                        <v-switch v-model="newProtectiveNotified"
                                                                  label="Yes"
                                                                  value="Yes"></v-switch>
                                                        <v-switch v-model="newProtectiveNotified"
                                                                  label="No" value="No"></v-switch>

                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <div
                                                v-if="newIncidentCategory.includes('Aspiration/Choking')">
                                                <v-row>
                                                    <v-col cols="12" sm="3"
                                                           class="grey lighten-4 pa-5 ma-2">

                                                        <h2>Type of Incident</h2>
                                                        <v-switch v-model="newChokingType"
                                                                  label="Choking"
                                                                  value="Choking"></v-switch>
                                                        <v-switch v-model="newChokingType"
                                                                  label="Aspiration"
                                                                  value="Aspiration"></v-switch>

                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                           class="grey lighten-4 pa-5 ma-2">

                                                        <h2>Aspirated/Choked Item</h2>
                                                        <v-switch v-model="newChokedItem"
                                                                  label="Food"
                                                                  value="Food"></v-switch>
                                                        <v-switch v-model="newChokedItem"
                                                                  label="Liquid"
                                                                  value="Liquid"></v-switch>
                                                        <v-switch v-model="newChokedItem"
                                                                  label="Object"
                                                                  value="Object"></v-switch>

                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                           class="grey lighten-4 pa-5 ma-2">
                                                        <v-text-field v-model="newChokingActions"
                                                                      label="Action Taken for Aspiration/Choking"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <div
                                                v-if="newIncidentCategory.includes('Behavior Intervention')">
                                                <v-row>
                                                    <v-col cols="12" sm="6"
                                                           class="grey lighten-4 pa-5 ">
                                                        <v-textarea
                                                            v-model="newInterventionCircumstances"
                                                            label="Intervention Circumstances"
                                                            outlined></v-textarea>
                                                    </v-col>
                                                    <v-col cols="12" sm="6"
                                                           class="grey lighten-4 pa-5 ">
                                                        <v-textarea
                                                            v-model="newInterventionJustification"
                                                            label="Intervention Justification"
                                                            outlined></v-textarea>
                                                    </v-col>
                                                    <v-col col="12" sm="6"
                                                           class="grey lighten-4 pa-5">
                                                        <h2>Intervention Cause</h2>
                                                        <v-switch v-model="newInterventionCause"
                                                                  label="Aggression Toward Other People"
                                                                  value="Aggression Toward Other People"></v-switch>
                                                        <v-switch v-model="newInterventionCause"
                                                                  label="Aggression Toward Client(s)"
                                                                  value="Aggression Toward Client(s)"></v-switch>
                                                        <v-switch v-model="newInterventionCause"
                                                                  label="Property Destruction"
                                                                  value="Property Destruction"></v-switch>
                                                        <v-switch v-model="newInterventionCause"
                                                                  label="Self-Injurious Behavior"
                                                                  value="Self-Injurious Behavior"></v-switch>
                                                        <v-switch v-model="newInterventionCause"
                                                                  label="Other (describe)"
                                                                  value="Other (describe)"></v-switch>
                                                        <v-text-field
                                                            v-if="newInterventionCause === 'Other (describe)'"
                                                            label="Other Detail"></v-text-field>
                                                        <v-datetime-picker
                                                            v-model="newInterventionDate"
                                                            label="Intervention Start Date"></v-datetime-picker>
                                                        <v-text-field
                                                            v-model="newInterventionDuration"
                                                            label="Intervention Duration"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="6"
                                                           class="grey lighten-4 pa-5">

                                                        <h3>**Physical restraints should not exceed
                                                            5 minutes; however, additional
                                                            restraints may be required. Indicate
                                                            number of restraints implemented and
                                                            duration of each restraint.</h3>
                                                        <v-text-field v-model="newFirstIntervention"
                                                                      label="First Intervention Duration (# of minutes)"></v-text-field>
                                                        <v-text-field
                                                            v-model="newSecondIntervention"
                                                            label="Second Intervention Duration (# of minutes)"></v-text-field>
                                                        <v-text-field v-model="newThirdIntervention"
                                                                      label="Third Intervention Duration (# of minutes)"></v-text-field>
                                                        <v-text-field
                                                            v-model="newFourthIntervention"
                                                            label="Fourth Intervention Duration (# of minutes)"></v-text-field>
                                                        <v-text-field v-model="newFifthIntervention"
                                                                      label="Fifth Intervention Duration (# of minutes)"></v-text-field>
                                                        <v-textarea
                                                            v-model="newAdditionalRestraints"
                                                            outlined
                                                            label="Additional Restraints"></v-textarea>
                                                        <v-text-field v-model="newAdditionalMinutes"
                                                                      label="Additional # of Minutes"></v-text-field>
                                                    </v-col>
                                                    <v-col col="12" sm="4"
                                                           class="grey lighten-4 pa-5">
                                                        <h2>Intervention Used</h2>
                                                        <v-switch v-model="newInterventionUsed"
                                                                  label="Enforced Compliance"
                                                                  value="Enforced Compliance"></v-switch>
                                                        <v-switch v-model="newInterventionUsed"
                                                                  label="Physical Requirements"
                                                                  value="Physical Requirements"></v-switch>
                                                        <v-switch v-model="newInterventionUsed"
                                                                  label="Mechanical Restraints"
                                                                  value="Mechanical Restraints"></v-switch>
                                                        <v-switch v-model="newInterventionUsed"
                                                                  label="Restriction By People"
                                                                  value="Restriction By People"></v-switch>
                                                        <v-switch v-model="newInterventionUsed"
                                                                  label="Seclusion Room"
                                                                  value="Seclusion Room"></v-switch>
                                                        <v-switch v-model="newInterventionUsed"
                                                                  label="Unwanted Restrictions"
                                                                  value="Unwanted Restrictions"></v-switch>
                                                        <v-switch v-model="newInterventionUsed"
                                                                  label="Other (describe)"
                                                                  value="Other (describe)"></v-switch>
                                                        <v-text-field
                                                            v-if="newInterventionUsed ==='Other (describe)'"
                                                            label="Other details"></v-text-field>
                                                        <div
                                                            v-if="newInterventionUsed ==='Physical Requirements'">
                                                            <span>Safety Care Restraint Used</span>
                                                            <v-checkbox v-model="newOnePerson"
                                                                        label="One Person Restraint"
                                                                        value="One Person Restraint"></v-checkbox>
                                                            <v-checkbox v-model="newTwoPerson"
                                                                        label="Two Person Restraint"
                                                                        value="Two Person Restraint"></v-checkbox>
                                                            <v-checkbox v-model="newMultiplePerson"
                                                                        label="Multiple Person Restraint"
                                                                        value="Multiple Person Restraint"></v-checkbox>
                                                            <v-checkbox v-model="newFloorRestraint"
                                                                        label="Floor Restraint"
                                                                        value="Floor Person Restraint"></v-checkbox>
                                                            <v-checkbox
                                                                v-model="newTransportRestraint"
                                                                label="Transport Restraint"
                                                                value="Transport Restraint"></v-checkbox>
                                                        </div>
                                                    </v-col>
                                                    <v-col col="12" sm="4"
                                                           class="grey lighten-4 pa-5">
                                                        <h2>Intervention in Behavior Support
                                                            Plan</h2>
                                                        <v-switch v-model="newInterventionPlan"
                                                                  label="Yes"
                                                                  value="Yes"></v-switch>
                                                        <v-switch v-model="newInterventionPlan"
                                                                  label="No" value="No"></v-switch>
                                                    </v-col>
                                                    <v-col col="12" sm="4"
                                                           class="grey lighten-4 pa-5">
                                                        <h2>Behavior Specialist Notified?</h2>
                                                        <v-switch v-model="newBehaviorSpecialist"
                                                                  label="Yes"
                                                                  value="Yes"></v-switch>
                                                        <v-switch v-model="newBehaviorSpecialist"
                                                                  label="No" value="No"></v-switch>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <div
                                                v-if="newIncidentCategory.includes('Compromised Environment')">
                                                <v-row>
                                                    <v-col cols="12" sm="4"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Compromised Environment Type</h2>
                                                        <v-switch v-model="newEnvironment"
                                                                  label="Living"
                                                                  value="Living"></v-switch>
                                                        <v-switch v-model="newEnvironment"
                                                                  label="Working/Day"
                                                                  value="Working/Day"></v-switch>
                                                    </v-col>
                                                    <v-col cols="12" sm="4"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Action Taken</h2>
                                                        <v-switch v-model="newEvacuated"
                                                                  label="Not Evacuated"
                                                                  value="Not Evacuated"></v-switch>
                                                        <v-switch v-model="newEvacuated"
                                                                  label="Evacuated"
                                                                  value="Evacuated"></v-switch>
                                                    </v-col>
                                                    <v-col cols="12" sm="3"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>New Location (if applicable)</h2>
                                                        <v-text-field v-model="newLocation"
                                                                      label="New Location"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <div
                                                v-if="newIncidentCategory.includes('Drug/Alcohol')">
                                                <v-row>
                                                    <v-col cols="12" sm="12"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Substance Type (Select all that
                                                            apply)</h2>
                                                        <v-switch v-model="newSubAlcohol"
                                                                  label="Alcohol"
                                                                  value="Alcohol"></v-switch>
                                                        <v-switch v-model="newSubDrugs"
                                                                  label="Illegal Drugs"
                                                                  value="Illegal Drugs"></v-switch>
                                                        <v-switch v-model="newSubMedications"
                                                                  label="Over the Counter Medication"
                                                                  value="Over the Counter Medication"></v-switch>
                                                        <v-switch v-model="newSubPrescriptions"
                                                                  label="Prescription Medication"
                                                                  value="Prescription Medication"></v-switch>
                                                        <v-switch v-model="newSOther"
                                                                  label="Other (describe)"
                                                                  value="Other (describe)"></v-switch>
                                                        <v-text-field v-model="newSubOther"
                                                                      label="Other details"
                                                                      v-if="newSOther === 'Other (describe)'"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <div v-if="newIncidentCategory.includes('Fatality')">
                                                <v-row>
                                                    <v-col cols="12" sm="12"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Fatality Status</h2>
                                                        <v-switch v-model="newFatality"
                                                                  label="Expected"
                                                                  value="Expected"></v-switch>
                                                        <v-switch v-model="newFatality"
                                                                  label="Not Expected"
                                                                  value="Not Expected"></v-switch>
                                                        <v-switch v-model="newFatality"
                                                                  label="Not Applicable"
                                                                  value="Not Applicable"></v-switch>
                                                        <div v-if="newFatality === 'Not Expected'">
                                                            <v-switch v-model="newUnexpected"
                                                                      label="Homicide"></v-switch>
                                                            <v-switch v-model="newUnexpected"
                                                                      label="Suicide"></v-switch>
                                                            <v-switch v-model="newUnexpected"
                                                                      label="Other (describe)"></v-switch>
                                                            <v-text-field
                                                                v-if="newUnexpected === 'Other (describe)'"
                                                                v-model="newFatalityOther"></v-text-field>
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="12" sm="12"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Was the Client Receiving Hospice
                                                            Care</h2>
                                                        <v-switch v-model="newHospice" label="Yes"
                                                                  value="Yes"></v-switch>
                                                        <v-switch v-model="newHospice" label="No"
                                                                  value="No"></v-switch>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <!-- <div v-if="newIncidentCategory.includes('Hospital')">
                    <v-col cols="12" sm="12" >
                    <h2>drug/alcohol</h2>
                    </v-col>
                    </div> -->
                                        <v-col cols="12">
                                            <div v-if="newIncidentCategory.includes('Injury')">
                                                <v-row>
                                                    <v-col cols="12" sm="12"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Injured Body Parts (Select All That
                                                            Apply)</h2>
                                                    </v-col>
                                                    <v-col cols="12" sm="3"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <v-switch v-model="newAbdomen"
                                                                  label="Abdomen"
                                                                  value="Abdomen"></v-switch>
                                                        <v-switch v-model="newBack" label="Back"
                                                                  value="Back"></v-switch>
                                                        <v-switch v-model="newButtocks"
                                                                  label="Buttocks"
                                                                  value="Buttocks"></v-switch>
                                                        <v-switch v-model="newChest" label="Chest"
                                                                  value="Chest"></v-switch>
                                                    </v-col>
                                                    <v-col cols="12" sm="3"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <v-switch v-model="newFace" label="Face"
                                                                  value="Face"></v-switch>
                                                        <v-switch v-model="newGenitals"
                                                                  label="Genitals"
                                                                  value="Genitals"></v-switch>
                                                        <v-switch v-model="newHead" label="Head"
                                                                  value="Head"></v-switch>
                                                        <v-switch v-model="newNeck" label="Neck"
                                                                  value="Neck"></v-switch>
                                                    </v-col>
                                                    <v-col cols="12" sm="3"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <v-switch v-model="newPelvis" label="Pelvis"
                                                                  value="Pelvis"></v-switch>
                                                        <v-switch v-model="newLeftAnkle"
                                                                  label="Left Ankle"
                                                                  value="Left Ankle"></v-switch>
                                                        <v-switch v-model="newLeftArm"
                                                                  label="Left Arm"
                                                                  value="Left Arm"></v-switch>
                                                        <v-switch v-model="newLeftFoot"
                                                                  label="Left Foot"
                                                                  value="Left Foot"></v-switch>
                                                    </v-col>
                                                    <v-col cols="12" sm="3"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <v-switch v-model="newLeftHand"
                                                                  label="Left Hand"
                                                                  value="Left Hand"></v-switch>
                                                        <v-switch v-model="newLeftKnee"
                                                                  label="Left Knee"
                                                                  value="Left Knee"></v-switch>
                                                        <v-switch v-model="newLeftLeg"
                                                                  label="Left Leg"
                                                                  value="Left Leg"></v-switch>
                                                        <v-switch v-model="newLeftShoulder"
                                                                  label="Left Shoulder"
                                                                  value="Left Shoulder"></v-switch>
                                                    </v-col>
                                                    <v-col cols="12" sm="3"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <v-switch v-model="newLeftWrist"
                                                                  label="Left Wrist"
                                                                  value="Left Wrist"></v-switch>
                                                        <v-switch v-model="newLeftHip"
                                                                  label="Left Hip"
                                                                  value="Left Hip"></v-switch>
                                                        <v-switch v-model="newRightAnkle"
                                                                  label="Right Ankle"
                                                                  value="Right Ankle"></v-switch>
                                                        <v-switch v-model="newRightArm"
                                                                  label="Right Arm"
                                                                  value="Right Arm"></v-switch>
                                                    </v-col>
                                                    <v-col cols="12" sm="3"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <v-switch v-model="newRightFoot"
                                                                  label="Right Foot"
                                                                  value="Right Foot"></v-switch>
                                                        <v-switch v-model="newRightHand"
                                                                  label="Right Hand"
                                                                  value="Right Hand"></v-switch>
                                                        <v-switch v-model="newRightKnee"
                                                                  label="Right Knee"
                                                                  value="Right Knee"></v-switch>
                                                        <v-switch v-model="newRightShoulder"
                                                                  label="Right Shoulder"
                                                                  value="Right Shoulder"></v-switch>
                                                    </v-col>
                                                    <v-col cols="12" sm="3"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <v-switch v-model="newRightWrist"
                                                                  label="Right Wrist"
                                                                  value="Right Wrist"></v-switch>
                                                        <v-switch v-model="newRightHip"
                                                                  label="Right Hip"
                                                                  value="Right Hip"></v-switch>
                                                        <v-switch v-model="newIOther"
                                                                  label="Other (describe)"
                                                                  value='Other (describe)'></v-switch>
                                                        <v-text-field v-model="newInjuredOther"
                                                                      v-if="newIOther === 'Other (describe)'"
                                                                      label="Other details"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="3"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Client's Role in Injury</h2>
                                                        <v-switch v-model="newInjuryRole"
                                                                  label="Perpetrator"
                                                                  value="Perpetrator"></v-switch>
                                                        <v-switch v-model="newInjuryRole"
                                                                  label="Victim"
                                                                  value="Victim"></v-switch>
                                                        <v-switch v-model="newInjuryRole"
                                                                  label="Victim and Perpetrator"
                                                                  value="Victim and Perpetrator"></v-switch>
                                                        <h2>Self-Inflicted Injury</h2>
                                                        <v-switch v-model="newSelfInflicted"
                                                                  label="Yes"
                                                                  value="Yes"></v-switch>
                                                        <v-switch v-model="newSelfInflicted"
                                                                  label="No" value="No"></v-switch>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <div
                                                v-if="newIncidentCategory.includes('Medication Errors')">
                                                <v-row>
                                                    <v-col cols="12"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Medication(s) Involved</h2>
                                                        <v-text-field label="Medications Involved"
                                                                      v-model="newMedicationInvolved"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Medication Error Type</h2>
                                                        <v-switch label="Missed Dose"
                                                                  value="Missed Dose"
                                                                  v-model="newMedicationError"></v-switch>
                                                        <v-switch label="Overdose" value="Overdose"
                                                                  v-model="newMedicationError"></v-switch>
                                                        <v-switch label="Underdose"
                                                                  value="Underdose"
                                                                  v-model="newMedicationError"></v-switch>
                                                        <v-switch label="Wrong Medication"
                                                                  value="Wrong Medication"
                                                                  v-model="newMedicationError"></v-switch>
                                                        <v-switch label="Late Med"
                                                                  value="Late Med"
                                                                  v-model="newMedicationError"></v-switch>
                                                        <v-switch label="Other (describe)"
                                                                  value="Other (describe)"
                                                                  v-model="newMedicationError"></v-switch>
                                                        <v-text-field label="Other details"
                                                                      v-model="newMedicationErrOther"
                                                                      v-if="newMedicationError === 'Other (describe)'"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <div
                                                v-if="newIncidentCategory.includes('Missing Person')">
                                                <v-row>
                                                    <v-col cols="12" sm="12"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Client Last Seen Date/Time</h2>
                                                        <v-menu
                                                            offset-y
                                                            min-width="290px"
                                                            max-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                    :value="newLastSeen"
                                                                    label="Client Last Seen"
                                                                    v-on="on"
                                                                    prepend-icon="events"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker v-model="newLastSeen"
                                                                           scrollable></v-date-picker>
                                                        </v-menu>

                                                        <v-text-field
                                                            label="Client Last Seen Location"
                                                            v-model="newLastLocation"></v-text-field>

                                                        <v-menu
                                                            offset-y
                                                            min-width="290px"
                                                            max-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                    :value="newDiscovered"
                                                                    label="Client Discovered Missing Date/Time"
                                                                    v-on="on"
                                                                    prepend-icon="events"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker v-model="newDiscovered"
                                                                           scrollable></v-date-picker>
                                                        </v-menu>
                                                    </v-col>
                                                    <v-col cols="12" sm="12"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Missing Person Unexplained
                                                            Circumstances</h2>
                                                        <v-switch label="Yes" value="Yes"
                                                                  v-model="newUnexplained"></v-switch>
                                                        <v-switch label="No" value="No"
                                                                  v-model="newUnexplained"></v-switch>
                                                    </v-col>
                                                    <v-col cols="12" sm="12"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Missing Person Involuntary
                                                            Circumstances</h2>
                                                        <v-switch label="Yes" value="Yes"
                                                                  v-model="newInvoluntary"></v-switch>
                                                        <v-switch label="No" value="No"
                                                                  v-model="newInvoluntary"></v-switch>
                                                    </v-col>
                                                    <v-col cols="12" sm="12"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Missing Person Suspicious
                                                            Circumstances</h2>
                                                        <v-switch label="Yes" value="Yes"
                                                                  v-model="newSuspicious"></v-switch>
                                                        <v-switch label="No" value="No"
                                                                  v-model="newSuspicious"></v-switch>
                                                    </v-col>
                                                    <v-col cols="12" sm="12"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Client Found</h2>
                                                        <v-switch label="Yes" value="Yes"
                                                                  v-model="newFound"></v-switch>
                                                        <v-switch label="No" value="No"
                                                                  v-model="newFound"></v-switch>
                                                    </v-col>
                                                    <v-col cols="12" sm="12"
                                                           class="grey lighten-4 pa-5 ma-1">
                                                        <h2>Current Living Status</h2>
                                                        <v-text-field label="Living Status"
                                                                      v-model="newLivingStatus"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <div
                                                v-if="newIncidentCategory.includes('Property Destruction')">
                                                <v-col cols="12" sm="12"
                                                       class="grey lighten-4 pa-5 ma-1">
                                                    <h2>Damaged Item</h2>
                                                    <v-text-field label="Damaged Item Name"
                                                                  v-model="newDamagedItem"></v-text-field>
                                                    <v-file-input
                                                        accept="image/*"
                                                        multiple
                                                        show-size
                                                        label="Select Items"
                                                        @change="selectDamagedPhotos">
                                                    </v-file-input>
                                                    <v-chip
                                                        @click="openIncidentImagesDialog()"
                                                        class="btn-view-image darken-4"
                                                        color="blue"
                                                        label
                                                        text-color="white"
                                                    >
                                                        <v-icon left>grid_view</v-icon>
                                                        View Images
                                                    </v-chip>

                                                    <v-text-field label="Owner of Damaged Property"
                                                                  v-model="newPropertyOwner"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12"
                                                       class="grey lighten-4 pa-5 ma-1">
                                                    <h2>Action Taken for Property Damage</h2>
                                                    <v-switch class="No Action" value="No Action"
                                                              label="No Action"
                                                              v-model="newPropertyAction"></v-switch>
                                                    <v-switch class="Repair" value="Repair"
                                                              label="Repair"
                                                              v-model="newPropertyAction"></v-switch>
                                                    <v-switch class="Replace" value="Replace"
                                                              label="Replace"
                                                              v-model="newPropertyAction"></v-switch>
                                                </v-col>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <div v-if="newIncidentCategory.includes('Seizure')">
                                                <v-col cols="12" sm="12"
                                                       class="grey lighten-4 pa-5 ma-1">
                                                    <h2>Describe the Seizure</h2>
                                                    <v-textarea label="Description" outlined
                                                                v-model="newSeizureDescription"></v-textarea>
                                                </v-col>
                                                <v-col cols="12" class="grey lighten-4 pa-5 ma-1">
                                                    <h2>Does the Client Have a Seizure
                                                        Diagnosis?</h2>
                                                    <v-switch label="Yes" value="Yes"
                                                              v-model="newSeizureDiagnosis"></v-switch>
                                                    <v-switch label="No" value="No"
                                                              v-model="newSeizureDiagnosis"></v-switch>

                                                    <v-menu
                                                        ref="menu"
                                                        v-model="menu"
                                                        :close-on-content-click="false"
                                                        :return-value.sync="date"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="auto"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                v-model="date"
                                                                label="Picker in menu"
                                                                prepend-icon="mdi-calendar"
                                                                readonly
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="date"
                                                            no-title
                                                            scrollable
                                                        >
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                text
                                                                color="primary"
                                                                @click="menu = false"
                                                            >
                                                                Cancel
                                                            </v-btn>
                                                            <v-btn
                                                                text
                                                                color="primary"
                                                                @click="$refs.menu.save(date)"
                                                            >
                                                                OK
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                    <v-text-field
                                                        label="Seizure Duration (in minutes)"
                                                        v-model="newSeizureDuration"></v-text-field>
                                                </v-col>
                                            </div>
                                        </v-col>
                                        <v-col cols="12">
                                            <div
                                                v-if="newIncidentCategory.includes('Suicide Attempt/Threat')">
                                                <v-col cols="12" sm="12"
                                                       class="grey lighten-4 pa-5 ma-1">
                                                    <h2>Suicide Type</h2>
                                                    <v-switch label="Attempt" value="Attempt"
                                                              v-model="newSuicideType"></v-switch>
                                                    <v-switch label="Threat" value="Threat"
                                                              v-model="newSuicideType"></v-switch>
                                                    <v-textarea outlined
                                                                label="Suicide Attempt/Threat Description"
                                                                v-model="newSuicideDescription"></v-textarea>
                                                    <v-textarea outlined
                                                                label="Actions Taken for Suicide"
                                                                hint="Should include efforts to monitor client for further suicidal thoughts and/or behavior"
                                                                v-model="newSuicideActions"></v-textarea>
                                                </v-col>
                                            </div>
                                        </v-col>

                                        <v-col cols="12">
                                            <div
                                                v-if="newIncidentCategory.includes('Other (describe)')">
                                                <v-col cols="12" sm="12"
                                                       class="grey lighten-4 pa-5 ma-1">
                                                    <h2>Other</h2>

                                                    <v-textarea outlined label="Other details"
                                                                v-model="newDetailsOther"></v-textarea>
                                                </v-col>
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"
                                    >

                                        Document Upload

                                    </v-col>

                                    <v-col cols="12">
                                        <v-file-input
                                            v-model="newDocument"
                                            class="pa-2"
                                            label="Select documents to upload"
                                            show-size
                                            filled
                                            multiple
                                            prepend-icon="mdi-camera"
                                            accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                            @change="fileSelected"

                                        >
                                            <template #selection="{ text, index }">
                                                <v-chip small label close color="primary"
                                                    @click:close="deleteChip(index)">{{ text }}
                                                </v-chip>
                                            </template>
                                        </v-file-input>

                                        <v-col cols="12" sm="12" md="12"
                                               v-for="(document, index) in newDocument" :key="document.url">
                                            <template v-if="document.type === 'pdf'">
                                                <LoadPDF :pdfFile="document.url"
                                                         :pdfName="document.name"/>
                                            </template>
                                            <template
                                                v-else-if="['jpg', 'jpeg', 'png'].includes(document.type)">
                                                <img :src="document.url" alt="" width="320"
                                                     height="240">
                                            </template>
                                            <template
                                                v-else-if="['doc', 'docx'].includes(document.type)">
                                                <VueDocPreview :value="document"
                                                               :type="'office'"
                                                               width="500"/>
                                            </template>
                                            <div v-if="document.url && document.url.length > 0">
                                                <v-icon @click="removeImage(index)"
                                                        title="Delete Document">mdi-delete
                                                </v-icon>
                                                <v-icon @click="downloadDocument(document)"
                                                        title="Download Document">mdi-download
                                                </v-icon>
                                            </div>
                                        </v-col>

                                        <v-file-input
                                            chips
                                            show-size
                                            class="pa-2"
                                            label="Select videos to upload"
                                            filled
                                            multiple
                                            prepend-icon="mdi-play-circle-outline"
                                            accept="video/mp4,video/x-m4v,video/*"
                                            @change="selectIncidentVideos"
                                        ></v-file-input>

                                        <div
                                            v-for="incidentVideoUrl in selectedIncidentReport.IncidentVideos"
                                            :key="incidentVideoUrl"
                                        >
                                            <video width="320" height="240" controls>
                                                <source :src="incidentVideoUrl" type="video/mp4">
                                                <source :src="incidentVideoUrl" type="video/ogg">
                                                Your browser does not support the
                                                tag.
                                            </video>
                                        </div>
                                    </v-col>


                                    <v-col cols="12" class="white--text text-uppercase text-center"
                                           style="background-color: #2b3990; border-radius: 10px">
                                        Detailed Description of Incident
                                    </v-col>

                                    <v-col cols="12">**Please provide a detailed and specific
                                        third-person description of the incident, including what
                                        circumstances and
                                        antecedents that led up to the incident and/or seemed to
                                        cause the incident, how each person was involved, what
                                        Safety Care technique
                                        was utilized (i.e., one-hand/two-hand wrist grab release,
                                        one-hand/two-hand hair pull release, back/front choke
                                        release, bite release),
                                        what specific Safety Care restraint was utilized (i.e., One
                                        Person Restraint, Two Person Restraint, Multiple Person
                                        Restraint, Transport
                                        Restraint or any Floor Restraints), how the client was
                                        verbally or physically redirected (e.g., “staff verbally
                                        prompted client to
                                        discontinue harmful behavior,” “staff placed arm around
                                        shoulder of client and escorted her away from the group”),
                                        and the outcome of the
                                        incident. The description should simply state the facts of
                                        what occurred and should not provide information that
                                        reflects or states an
                                        opinion. If the incident involved a suicidal threat and/or
                                        attempt, include information regarding efforts made by staff
                                        to monitor the
                                        client for any further indications of suicidal thoughts
                                        and/or behavior.
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-textarea
                                            v-model="newCircumstances"
                                            label="Circumstances Leading up to Incident"
                                            outlined
                                        ></v-textarea>
                                    </v-col>


                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-textarea
                                            v-model="newIncidentDescription"
                                            label="Incident Description"
                                            outlined
                                        ></v-textarea>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="6">
                                        <v-textarea
                                            v-model="newOutcome"
                                            label="Outcome of the Incident"
                                            outlined
                                        ></v-textarea>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="6">
                                        <v-textarea
                                            v-model="newStaffAssessment"
                                            label="Staff Self Assessment"
                                            outlined
                                            :rules='requiredField'
                                            hint="How could staff have avoided this situation?"

                                        ></v-textarea>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <v-checkbox
                                            label="Staff Signature"
                                            v-model="staffSignature"
                                            @click="addStaffSignature()"
                                            :rules='requiredField'
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field v-if="staffSignature"
                                                      v-model="newStaffSignature" label="Signed By"
                                                      readonly></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            label="Phone"
                                            v-model="newStaffPhone"
                                            v-mask="'(###) ###-####'"
                                        ></v-text-field>
                                    </v-col>


                                    <v-col cols="12" class="white--text text-uppercase text-center"
                                           style="background-color: #2b3990; border-radius: 10px">
                                        Supervisor Use Only
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field
                                            label="Supervisor Name"
                                            v-model="newSupervisorName"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-checkbox
                                            label="Supervisor Signature"
                                            v-model="supervisorSignature"
                                            @click="addSignature()"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field v-if="supervisorSignature"
                                                      v-model="newSupervisorSignature"
                                                      label="Signed By" readonly></v-text-field>
                                    </v-col>


                                    <v-col class="d-flex" cols="12" sm="6">
                                        <v-text-field
                                            v-model="newSupervisorPhone"
                                            label="Supervisor Phone"
                                            v-mask="'(###) ###-####'"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="6"></v-col>


                                    <v-col cols="12" class="white--text text-uppercase text-center"
                                           style="background-color: #2b3990; border-radius: 10px">
                                        Supervisors Manager
                                    </v-col>

                                    <v-col cols="12">
                                        <v-checkbox
                                            label="Supervisors Manager Signature"
                                            v-model="managerSignature"
                                            @click="addManagerSignature()"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field v-if="managerSignature"
                                                      v-model="newManagerSignature"
                                                      label="Supervisor Name"></v-text-field>
                                    </v-col>


                                    <v-col class="d-flex" cols="12" sm="6">
                                        <v-text-field
                                            v-model="newSupportCoordinator"
                                            label="Support Coordinator"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6"></v-col>


                                    <v-col cols="12">
                                        <h3>Support Coordinator Notified</h3>
                                        <v-radio-group v-model="newSupportCoordinatorNotified">
                                            <v-radio label="Yes" value="Yes"></v-radio>
                                            <v-radio label="No" value="No"></v-radio>
                                        </v-radio-group>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field label="Guardian Name"
                                                      v-model="newGuardian"></v-text-field>
                                        <h3>Guardian Notified?</h3>
                                        <v-radio-group v-model="newGuardianNotified">
                                            <v-radio label="Yes" value="Yes"></v-radio>
                                            <v-radio label="No" value="No"></v-radio>
                                        </v-radio-group>

                                    </v-col>

                                    <v-col cols="12" class="white--text text-uppercase text-center"
                                           style="background-color: #2b3990; border-radius: 10px">
                                        For Administrative Use Only
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-menu
                                            offset-y
                                            min-width="290px"
                                            max-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    :value="newReportReceived"
                                                    label="Incident Report Received"
                                                    v-on="on"
                                                    prepend-icon="events"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="newReportReceived"
                                                           scrollable></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="6"></v-col>
                                    <v-col class="d-flex" cols="12" sm="6">
                                        <h3>Report Reviewed By</h3>

                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-checkbox @click="addReviewedSignature()"
                                                    label="Signature"
                                                    v-model="reviewedSignature"></v-checkbox>
                                        <v-text-field
                                            v-if="reviewedSignature"
                                            label="Report Reviewed By"
                                            v-model="newReviewedSignature"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col class="d-flex" cols="12" sm="6">
                                        <v-text-field
                                            v-model="newAdminTitle"
                                            label="Title"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6"></v-col>
                                    <v-col cols="12" sm="12">
                                        <h3>DSPD/OL Notification Submitted</h3>

                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <h3>DSPD clients need to be uploaded to UPI and DCFS clients
                                            need to be uploaded to Office of Licensing (OL).
                                        </h3>

                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-radio-group v-model="newNotificationSubmitted">
                                            <v-radio
                                                label="Yes"
                                                value="Yes"
                                            ></v-radio>
                                            <v-radio
                                                label="No"
                                                value="No"
                                            ></v-radio>
                                        </v-radio-group>

                                    </v-col>

                                    <v-col cols="12" sm="12"
                                           v-if="newNotificationSubmitted === 'Yes'">
                                        <v-menu
                                            offset-y
                                            min-width="290px"
                                            max-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-datetime-picker
                                                    v-model="newReportSubmittedDate"
                                                    label="Report Submitted Date and Time"
                                                    prepend-icon="events"
                                                    v-on="on"
                                                ></v-datetime-picker>
                                            </template>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <v-checkbox
                                            v-show="newNotificationSubmitted === 'Yes'"
                                            label="Staff Signature that Notified Report"
                                            v-model="staffSignatureNotified"
                                            @click="addStaffSignatureNotification()"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field v-if="staffSignatureNotified"
                                                      v-model="newReportSignature" label="Signed By"
                                                      readonly></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <v-checkbox
                                            v-show="newNotificationSubmitted === 'Yes'"
                                            label="Staff Signature that Reviewed Report"
                                            v-model="reviewedDSPDSignature"
                                            @click="addDSPDReviewedSignature()"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field v-if="reviewedDSPDSignature"
                                                      v-model="newReviewedDSPDSignature"
                                                      label="Report Reviewed by:"
                                                      readonly></v-text-field>
                                    </v-col>


                                    <v-col class="d-flex" cols="12" sm="6">
                                        <h3>DSPD/OL Report Submitted</h3>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <v-radio-group v-model="newReportSubmitted">
                                            <v-radio
                                                label="Yes"
                                                value="Yes"
                                            ></v-radio>
                                            <v-radio
                                                label="No"
                                                value="No"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-col>

                                    <v-col cols="12" v-if="newReportSubmitted === 'Yes'">
                                        <v-menu
                                            offset-y
                                            min-width="290px"
                                            max-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-datetime-picker
                                                    v-model="newOLReport"
                                                    label="DSPD/OL Report Submitted Date and Time"
                                                    prepend-icon="events"
                                                    v-on="on"
                                                ></v-datetime-picker>
                                            </template>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <v-checkbox
                                            v-show="newReportSubmitted === 'Yes'"
                                            label="Staff Signature that Submitted Report"
                                            v-model="submittedDSPDSignature"
                                            @click="addDSPDSubmittedSignature()"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field v-if="submittedDSPDSignature"
                                                      v-model="newSubmittedDSPDSignature"
                                                      label="Submitted by: "
                                                      readonly></v-text-field>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-textarea
                                            v-model="newAdministrativeNotes"
                                            label="Administrative Notes"
                                            outlined
                                        ></v-textarea>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrint()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="!newIncident"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn class="white--text" color="#259647" @click="addIncident()" v-if="newIncident && !isAuditorRole">Save
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="updateIncident()" v-if="!newIncident && !isAuditorRole">Update
                        </v-btn
                        >
                        <v-btn color="blue darken-1" text @click="clearFieldsAndBack">Cancel</v-btn>
                    </v-card-actions>
                    <v-dialog v-model="isOpenIncidentImagesDialog" max-width="800px">
                        <v-card>
                            <v-card-title>
                                <h5>Incident Damaged Photos</h5>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col v-for="photo in selectedIncidentReport.DamagedPhotos"
                                               :key="photo"
                                               class="d-flex child-flex"
                                               cols="4">
                                            <v-img
                                                :src="photo"
                                                :lazy-src="photo"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                            >
                                                <v-icon small class="ma-2" @click="downloadImage(photo)">
                                                    file_download
                                                </v-icon>
                                                <template v-slot:placeholder>`
                                                    <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                    >
                                                        <v-progress-circular
                                                            indeterminate
                                                            color="grey lighten-5"
                                                        ></v-progress-circular>
                                                    </v-row>
                                                </template>
                                            </v-img>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../../components/ClientNav.vue'
import Foot from '../../../components/Footer'
import renameFileHelper from '../../../mixins/renameFileHelper'
import DateTimeUtil from '../../../../utils/date-time.util.js';
import Swal from 'sweetalert2';
import LoadPDF from "@/components/LoadPDF.vue";
import PrintUtil from "../../../../utils/print-util";

const IncidentService = require('../../../service/incident.service');
import VueDocPreview from 'vue-doc-preview';

const url = require("../../../client_config/config").url;

export default {
    mixins: [renameFileHelper],
    components: {
        LoadPDF,
        ClientNav,
        Foot,
        VueDocPreview,
    },
    data() {
        return {
            headers: [
                {
                    text: 'Incident Category',
                    align: 'start',
                    sortable: true,
                    value: 'Type',
                },
                {text: "Incident Date and Approximate Time", value: "IncidentDateTimeTable"},
                {text: "Program", value: "Program"},
                {text: "Incident Location", value: "IncidentLocation"},
                {text: "DSPD/OL Notification Submitted", value: "ReportSubmitted"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            newIncident: false,
            msg: false,
            hospital: false,
            lawEnforcement: false,
            medicalCare: false,
            otherHospital: false,
            otherMedical: false,
            otherLaw: false,
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            reportSubmittedMenu: false,
            search: "",
            text: "",
            incident: {},
            incidents: [],
            units: [],
            users: [],
            codes: [],
            tempData: [],
            clientID: this.$route.params.clientID,
            incidentID: this.$route.params.id,
            token: localStorage.getItem('token'),
            userID: localStorage.getItem("userID"),
            unitID: localStorage.getItem('unitID'),
            staff: localStorage.getItem("Name"),
            staffRole: localStorage.getItem("userRole"),
            category: ["Behavioral", "Medical", "Hospital", "Injury", "Property Damage"],
            type: ["Abuse/Neglect/Exploitation", "Aspiration/Choking", "Behavior Intervention", "Compromised Environment", "Drug/Alcohol",
                "Fatality", "Hospital", "Injury", "Medication Errors", "Late Med", "Missing Person", "Property Destruction",
                "Seizure", "Suicide Attempt/Threat", "Theft", "Other (Describe)"],
            location: ["Community", "Day Program", "Home", "Place of Employment", "Relative's Home", "School",
                "Vehicle", "Other"],
            roles: ["Family Guardian", "Provider Staff", "Unknown", "Other Client", "Support Coordinator", "Other (describe)"],
            involvement: ["Direct Involvement", "Perpetrator", "Perpetrator and Victim", "Support Coordinator", "Victim", "Witness Only", "Other"],
            organization: ["911", "APS", "Behaviorist", "CPS", "Dental", "Guardian", "Hospital", "Law Enforcement", "Medical Clinic", "Natural Supports",
                "Parent", "Pharmacy", "Physician Clinic", "Poison Control", "Primary Care", "Provider Staff", "Therapist", "Urgent Care", "Other (Describe)"],
            incidentCategory: ["Abuse/Neglect/Exploitation", "Aspiration/Choking", "Behavior Intervention", "Compromised Environment", "Drug/Alcohol", "Elopement", "Fatality", "Hospital", "Injury", "Medication Errors", "Missing Person", "Physical Aggression", "Property Destruction", "Restrained", "Seizure", "Suicide Attempt/Threat", "Theft", "Other (describe)"],
            titleForm: "New Incident",
            newType: "",
            newIncidentDateTime: "",
            newTodaysDate: "",
            newProgram: "",
            newIncidentLocation: "",
            newIncidentDiscovered: "",
            newStreet: "",
            newCity: "",
            newState: "",
            newZipCode: "",
            newIncidentLocationType: "",
            newPersonInvolved1: "",
            newTitle1: "",
            newPhone1: "",
            newRoles1: "",
            newInvolvement1: "",
            newPersonInvolved2: "",
            newTitle2: "",
            newPhone2: "",
            newRoles2: "",
            newInvolvement2: "",
            newPersonInvolved3: "",
            newTitle3: "",
            newPhone3: "",
            newRoles3: "",
            newInvolvement3: "",
            newOrganization1: "",
            newOrgPhone1: "",
            newOrgType1: "",
            newOrgFullName1: "",
            newOrgTitle1: "",
            newOrgNotDate1: "",
            newOrgCaseNum1: "",
            newHospitalName: "",
            newHospitalDate: "",
            newFacilityType: "",
            newOtherHospital: "",
            new911Call: "",
            newMedicalClinic: "",
            newER: "",
            newAssessedClient: "",
            newFirstAid: "",
            newPoison: "",
            newNurseContacted: "",
            newOtherMedical: "",
            newLaw: "",
            newLawOther: "",
            newInvolved: [],
            newIncidentCategory: [],
            newAbuseCategory: "",
            newAbuseType: "",
            newClientRole: "",
            newProtectiveNotified: "",
            newChokingType: "",
            newChokedItem: "",
            newChokingActions: "",
            newInterventionCircumstances: "",
            newInterventionJustification: "",
            newInterventionCause: "",
            newInterventionDate: "",
            newInterventionDuration: "",
            newFirstIntervention: "",
            newSecondIntervention: "",
            newThirdIntervention: "",
            newFourthIntervention: "",
            newFifthIntervention: "",
            newAdditionalRestraints: "",
            newAdditionalMinutes: "",
            newInterventionUsed: "",
            newOnePerson: "",
            newTwoPerson: "",
            newMultiplePerson: "",
            newFloorRestraint: "",
            newTransportRestraint: "",
            newInterventionPlan: "",
            newBehaviorSpecialist: "",
            newEnvironment: "",
            newEvacuated: "",
            newLocation: "",
            newSubAlcohol: "",
            newSubDrugs: "",
            newSubMedications: "",
            newSubPrescriptions: "",
            newSOther: "",
            newSubOther: "",
            newFatality: "",
            newUnexpected: "",
            newHospice: "",
            newFatalityOther: "",
            newAbdomen: "",
            newBack: "",
            newButtocks: "",
            newChest: "",
            newFace: "",
            newGenitals: "",
            newHead: "",
            newNeck: "",
            newPelvis: "",
            newLeftAnkle: "",
            newLeftArm: "",
            newLeftFoot: "",
            newLeftHand: "",
            newLeftKnee: "",
            newLeftLeg: "",
            newLeftShoulder: "",
            newLeftWrist: "",
            newLeftHip: "",
            newRightAnkle: "",
            newRightArm: "",
            newRightFoot: "",
            newRightHand: "",
            newRightKnee: "",
            newRightShoulder: "",
            newRightWrist: "",
            newRightHip: "",
            newIOther: "",
            newInjuredOther: "",
            newInjuryRole: "",
            newSelfInflicted: "",
            newMedicationInvolved: "",
            newMedicationError: "",
            newAdverseReaction: "",
            newAdverseDescription: "",
            newMedicationErrOther: "",
            newLastSeen: "",
            newLastLocation: "",
            newDiscovered: "",
            newUnexplained: "",
            newInvoluntary: "",
            newSuspicious: "",
            newFound: "",
            newLivingStatus: "",
            newDamagedItem: "",
            newDamagedPhoto: "",
            newIncidentVideo: "",
            newPropertyOwner: "",
            newPropertyAction: "",
            newSeizureDescription: "",
            newSeizureDiagnosis: "",
            newSeizureDuration: "",
            newSuicideType: "",
            newSuicideDescription: "",
            newSuicideActions: "",
            newDetailsOther: "",
            newCircumstances: "",
            newNotified: "",
            newIncidentType: "",
            newIncidentDescription: "",
            newOutcome: "",
            newStaffAssessment: "",
            newSupervisorName: "",
            newStaffSignature: "",
            newStaffPhone: "",
            newSupervisorSignature: "",
            newSupervisorPhone: "",
            newManagerSignature: "",
            newDocument: [],
            newSupportCoordinator: "",
            newSupportCoordinatorNotified: "",
            newGuardian: "",
            newGuardianNotified: "",
            newReportReceived: "",
            newReviewedSignature: "",
            newAdminTitle: "",
            newNotificationSubmitted: "",
            staffSignatureNotified: false,
            newReportSubmitted: "",
            submittedDSPDSignature: "",
            newSubmittedDSPDSignature: "",
            newReportSubmittedDate: "",
            newReportSigned: false,
            newReportSignature: "",
            newDSPDReviewedSignature: "",
            reviewedDSPDSignature: "",
            newReviewedDSPDSignature: "",
            staffSignatureNotification: '',
            newAdministrativeNotes: "",
            humanRights: "",
            supportStrategy: "",
            newOLReport: "",
            restriction: null,
            rights: [],
            person2: false,
            person3: false,
            staffSignature: false,
            supervisorSignature: false,
            managerSignature: false,
            reviewedSignature: false,
            calendarMenu: false,
            calendar2Menu: false,
            calendarMenu10: false,
            calendarMenu11: false,
            userState: localStorage.getItem('userState'),
            editedIndex: -1,
            strategies: [],
            strategy: null,
            isLoading: true,
            uploadFile: "",
            requiredField: [v => !!v || 'This is required'],
            damagedPhotos: [],
            incidentVideos: [],
            isOpenIncidentImagesDialog: false,
            photos: [],
            selectedIncidentReport: {},
            selectedPhoto: '',
            downloadUrl: ''
        };
    },
    computed: {
        formTitle() {
            return this.editedIndex !== 1 ? "New Item" : "Edit Item";
        },
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        },
        //check what is the use for this

        // clientName() {
        //     // `this` points to the component instance
        //     return this.$store.state.clients.client.Name;
        // }
    },

    mounted() {
        if (!this.newIncident) {
            this.getIncident();
        }

        window.addEventListener('keydown', async (event) => {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, downloadUrl, this.incidentID, this.token,'UtahIncidentReport');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.incidentID, this.token, 'UtahIncidentReport');
        });
    },

    watch: {},

    created() {

        this.newIncident = this.$route.query.newIncident === 'true';

        let incidentId = this.$route.query.view;

        if (incidentId) {
            IncidentService.getById(incidentId).then((response) => {
                this.initializeFormData(response.data.incident);
            })

            console.log('getting data')
        }

        if (this.selectedIncidentReport && this.selectedIncidentReport.Documents && this.selectedIncidentReport.Documents.length) {
            this.newDocument = this.selectedIncidentReport.Documents.map(url => {
                return {
                    url: url,
                    type: this.getFileType(url)
                };
            });
        }

      this.getSupportStrategies();
      this.getRights();
      this.getUnits();
    },

    methods: {
        initialize() {
            this.incidents = [];
        },
        validate() {
            return this.$refs.form.validate();
        },
        validateReset() {
            if (this.$refs.form !== undefined) {
                this.$refs.form.reset();
            }
        },

        openIncidentImagesDialog() {
            this.isOpenIncidentImagesDialog = true;
        },

        selectDamagedPhotos(damagedPhotos) {
            this.damagedPhotos = damagedPhotos;
        },

        selectIncidentVideos(incidentVideos) {
            this.incidentVideos = incidentVideos;
        },

        async uploadDamagedPhotos(files) {
            const formData = new FormData();
            formData.append('incidentId', this.incidentID);

            for (let file of files) {
                formData.append('damagedPhoto[]', file);
            }

            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };

            try {
                await axios.post(`${url}/incidents/damagedPhoto/upload`, formData, config);
            } catch (e) {
                console.log({e});
            }
        },

        async uploadIncidentVideos(files) {
            const formData = new FormData();
            formData.append('incidentId', this.incidentID);

            for (let file of files) {
                formData.append('incidentVideos[]', file);
            }

            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };

            try {
                await axios.post(`${url}/incidents/video/upload`, formData, config);
            } catch (e) {
                console.log({e});
            }
        },

        getUnits() {
            axios.get(`${url}/units/state/${this.userState}`).then(async res => {
                res.data.units.forEach(item => {
                    this.units.push(item.Name)
                })

            });
        },

        addIncident() {
            if (!this.newIncidentDateTime) {
                Swal.fire({
                    title: "Missing Information",
                    text: "Please input the Incident Date & Approximate Time.",
                    icon: "warning",
                    confirmButtonText: 'OK'
                });
            }

            if (!this.newIncidentDiscovered) {
                Swal.fire({
                    title: "Missing Information",
                    text: "Please input the Incident Discovered Date & Time.",
                    icon: "warning",
                    confirmButtonText: 'OK'
                });
            }

            if (this.validate()) {
                const payload = {
                    AbuseType: this.newAbuseType,
                    Abdomen: this.newAbdomen,
                    AdditionalMinutes: this.newAdditionalMinutes,
                    AdditionalRestraints: this.newAdditionalRestraints,
                    AdministrativeNotes: this.newAdministrativeNotes,
                    AdminTitle: this.newAdminTitle,
                    AdverseDescription: this.newAdverseDescription,
                    AdverseReaction: this.newAdverseReaction,
                    AssessedClient: this.newAssessedClient,
                    Back: this.newBack,
                    BehaviorSpecialist: this.newBehaviorSpecialist,
                    Buttocks: this.newButtocks,
                    Call: this.new911Call,
                    Chest: this.newChest,
                    ChokedItem: this.newChokedItem,
                    ChokingActions: this.newChokingActions,
                    ChokingType: this.newChokingType,
                    Circumstances: this.newCircumstances,
                    City: this.newCity,
                    ClientID: this.clientID,
                    ClientRole: this.newClientRole,
                    DamagedItem: this.newDamagedItem,
                    DamagedPhoto: this.newDamagedPhoto,
                    DetailsOther: this.newDetailsOther,
                    Discovered: this.newDiscovered,
                    Environment: this.newEnvironment,
                    ER: this.newER,
                    Evacuated: this.newEvacuated,
                    Face: this.newFace,
                    FacilityType: this.newFacilityType,
                    Fatality: this.newFatality,
                    FatalityOther: this.newFatalityOther,
                    FifthIntervention: this.newFifthIntervention,
                    FirstAid: this.newFirstAid,
                    FirstIntervention: this.newFirstIntervention,
                    FloorRestraint: this.newFloorRestraint,
                    Found: this.newFound,
                    FourthIntervention: this.newFourthIntervention,
                    Genitals: this.newGenitals,
                    Guardian: this.newGuardian,
                    GuardianNotified: this.newGuardianNotified,
                    Head: this.newHead,
                    Hospice: this.newHospice,
                    Hospital: this.hospital,
                    HospitalDate: DateTimeUtil.toUTCISOString(this.newHospitalDate),
                    HospitalName: this.newHospitalName,
                    HumanRights: this.humanRights,
                    IncidentCategory: this.newIncidentCategory,
                    IncidentDateTime: DateTimeUtil.toUTCISOString(this.newIncidentDateTime),
                    IncidentDescription: this.newIncidentDescription,
                    IncidentDiscovered: DateTimeUtil.toUTCISOString(this.newIncidentDiscovered),
                    IncidentLocation: this.newIncidentLocation,
                    IncidentLocationType: this.newIncidentLocationType,
                    IncidentType: this.newIncidentType,
                    IncidentVideo: this.newIncidentVideo,
                    InjuredOther: this.newInjuredOther,
                    InjuryRole: this.newInjuryRole,
                    InterventionCause: this.newInterventionCause,
                    InterventionCircumstances: this.newInterventionCircumstances,
                    InterventionDate: this.newInterventionDate,
                    InterventionDuration: this.newInterventionDuration,
                    InterventionJustification: this.newInterventionJustification,
                    InterventionPlan: this.newInterventionPlan,
                    InterventionUsed: this.newInterventionUsed,
                    Involuntary: this.newInvoluntary,
                    Involved: this.newInvolved,
                    Involvement1: this.newInvolvement1,
                    Involvement2: this.newInvolvement2,
                    Involvement3: this.newInvolvement3,
                    LastLocation: this.newLastLocation,
                    LastSeen: this.newLastSeen,
                    Law: this.newLaw,
                    LawEnforcement: this.lawEnforcement,
                    LeftAnkle: this.newLeftAnkle,
                    LeftArm: this.newLeftArm,
                    LeftFoot: this.newLeftFoot,
                    LeftHand: this.newLeftHand,
                    LeftHip: this.newLeftHip,
                    LeftKnee: this.newLeftKnee,
                    LeftLeg: this.newLeftLeg,
                    LeftShoulder: this.newLeftShoulder,
                    LeftWrist: this.newLeftWrist,
                    LivingStatus: this.newLivingStatus,
                    Location: this.newLocation,
                    ManagerSignature: this.newManagerSignature,
                    ManagerSigned: this.managerSignature,
                    MedicalCare: this.medicalCare,
                    MedicalClinic: this.newMedicalClinic,
                    MedicationError: this.newMedicationError,
                    MedicationErrOther: this.newMedicationErrOther,
                    MedicationInvolved: this.newMedicationInvolved,
                    MultiplePerson: this.newMultiplePerson,
                    Neck: this.newNeck,
                    NotificationSubmitted: this.newNotificationSubmitted,
                    Notified: this.newNotified,
                    NurseContacted: this.newNurseContacted,
                    OLReport: this.newOLReport,
                    OnePerson: this.newOnePerson,
                    Organization1: this.newOrganization1,
                    OrgCaseNum1: this.newOrgCaseNum1,
                    OrgFullName1: this.newOrgFullName1,
                    OrgNotDate1: DateTimeUtil.toUTCISOString(this.newOrgNotDate1),
                    OrgPhone1: this.newOrgPhone1,
                    OrgTitle1: this.newOrgTitle1,
                    OrgType1: this.newOrgType1,
                    OtherHospital: this.newOtherHospital,
                    OtherLaw: this.newLawOther,
                    OtherMedical: this.newOtherMedical,
                    Outcome: this.newOutcome,
                    Pelvis: this.newPelvis,
                    PersonInvolved1: this.newPersonInvolved1,
                    PersonInvolved2: this.newPersonInvolved2,
                    PersonInvolved3: this.newPersonInvolved3,
                    Phone1: this.newPhone1,
                    Phone2: this.newPhone2,
                    Phone3: this.newPhone3,
                    Poison: this.newPoison,
                    Program: this.newProgram,
                    PropertyAction: this.newPropertyAction,
                    PropertyOwner: this.newPropertyOwner,
                    ProtectiveNotified: this.newProtectiveNotified,
                    ReportReceived: DateTimeUtil.toUTCISOString(this.newReportReceived),
                    ReportSignature: this.newReportSignature,
                    ReportSigned: this.staffSignatureNotified,
                    ReportSubmitted: this.newReportSubmitted,
                    ReportSubmittedDate: DateTimeUtil.toUTCISOString(this.newReportSubmittedDate),
                    Restriction: this.restriction,
                    ReviewedDSPDSignature: this.newReviewedDSPDSignature,
                    ReviewedSignature: this.newReviewedSignature,
                    ReviewedSigned: this.reviewedSignature,
                    RightAnkle: this.newRightAnkle,
                    RightArm: this.newRightArm,
                    RightFoot: this.newRightFoot,
                    RightHand: this.newRightHand,
                    RightHip: this.newRightHip,
                    RightKnee: this.newRightKnee,
                    RightShoulder: this.newRightShoulder,
                    RightWrist: this.newRightWrist,
                    Roles1: this.newRoles1,
                    Roles2: this.newRoles2,
                    Roles3: this.newRoles3,
                    SecondIntervention: this.newSecondIntervention,
                    SeizureDescription: this.newSeizureDescription,
                    SeizureDiagnosis: this.newSeizureDiagnosis,
                    SeizureDuration: this.newSeizureDuration,
                    SeizureStart: this.newSeizureStart,
                    SelfInflicted: this.newSelfInflicted,
                    StaffAssessment: this.newStaffAssessment,
                    StaffPhone: this.newStaffPhone,
                    StaffSignature: this.newStaffSignature,
                    StaffSignatureNotification: this.staffSignatureNotification,
                    StaffSigned: this.staffSignature,
                    State: this.newState,
                    Strategy: this.strategy,
                    Street: this.newStreet,
                    SubAlcohol: this.newSubAlcohol,
                    SubDrugs: this.newSubDrugs,
                    SubMedications: this.newSubMedications,
                    SubmittedDSPDSignature: this.newSubmittedDSPDSignature,
                    SubOther: this.newSubOther,
                    SubPrescriptions: this.newSubPrescriptions,
                    SuicideActions: this.newSuicideActions,
                    SuicideDescription: this.newSuicideDescription,
                    SuicideType: this.newSuicideType,
                    SupervisorName: this.newSupervisorName,
                    SupervisorPhone: this.newSupervisorPhone,
                    SupervisorSignature: this.newSupervisorSignature,
                    SupervisorSigned: this.supervisorSignature,
                    SupportCoordinator: this.newSupportCoordinator,
                    SupportCoordinatorNotified: this.newSupportCoordinatorNotified,
                    SupportStrategy: this.supportStrategy,
                    Suspicious: this.newSuspicious,
                    ThirdIntervention: this.newThirdIntervention,
                    Title1: this.newTitle1,
                    Title2: this.newTitle2,
                    Title3: this.newTitle3,
                    TodaysDate: DateTimeUtil.toUTCISOString(this.newTodaysDate),
                    TransportRestraint: this.newTransportRestraint,
                    TwoPerson: this.newTwoPerson,
                    Type: this.newType,
                    Unexpected: this.newUnexpected,
                    Unexplained: this.newUnexplained,
                    ZipCode: this.newZipCode,
                };
                const addIncidentUrl = `${url}/incidents`;
                this.showLoadingAddDialog();

                axios.post(addIncidentUrl, payload)
                    .then(async (response) => {
                            this.incidentID = response.data._id;

                            if (this.uploadFile !== null && this.uploadFile !== undefined && this.uploadFile.length) {
                                await this.uploadIncidentDocuments();
                            }

                            if (this.damagedPhotos && this.damagedPhotos.length) {
                                await this.uploadDamagedPhotos(this.damagedPhotos);
                            }

                            if (this.incidentVideos && this.incidentVideos.length) {
                                await this.uploadIncidentVideos(this.incidentVideos);
                            }

                            this.showSuccessAddDialog();
                            this.clearFieldsAndBack();
                        }
                    );
            } else {
                this.msg = true;
                this.text = "Please fill up all required fields";
            }
        },

        async generateDownloadUrl() {
            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            return `${url}/incidents/print?id=${this.incidentID}&tz=${encodeURIComponent(userTimeZone)}`;
        },

        async showPrint() {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(downloadUrl, this.incidentID, this.token, 'UtahIncidentReport');
        },

        updateIncident() {
            if (!this.newIncidentDateTime) {
                Swal.fire({
                    title: "Missing Information",
                    text: "Please input the Incident Date & Approximate Time.",
                    icon: "warning",
                    confirmButtonText: 'OK'
                });
            }

            if (!this.newIncidentDiscovered) {
                Swal.fire({
                    title: "Missing Information",
                    text: "Please input the Incident Discovered Date & Time.",
                    icon: "warning",
                    confirmButtonText: 'OK'
                });
            }

            if (this.validate()) {
                const payload = {
                    Abdomen: this.newAbdomen,
                    AbuseCategory: this.newAbuseCategory,
                    AbuseType: this.newAbuseType,
                    AdditionalMinutes: this.newAdditionalMinutes,
                    AdditionalRestraints: this.newAdditionalRestraints,
                    AdministrativeNotes: this.newAdministrativeNotes,
                    AdminTitle: this.newAdminTitle,
                    AdverseDescription: this.newAdverseDescription,
                    AdverseReaction: this.newAdverseReaction,
                    AssessedClient: this.newAssessedClient,
                    Back: this.newBack,
                    BehaviorSpecialist: this.newBehaviorSpecialist,
                    Buttocks: this.newButtocks,
                    Call: this.new911Call,
                    Chest: this.newChest,
                    ChokedItem: this.newChokedItem,
                    ChokingActions: this.newChokingActions,
                    ChokingType: this.newChokingType,
                    Circumstances: this.newCircumstances,
                    City: this.newCity,
                    ClientRole: this.newClientRole,
                    DamagedItem: this.newDamagedItem,
                    DamagedPhoto: this.newDamagedPhoto,
                    DetailsOther: this.newDetailsOther,
                    Discovered: this.newDiscovered,
                    Environment: this.newEnvironment,
                    ER: this.newER,
                    Evacuated: this.newEvacuated,
                    Face: this.newFace,
                    FacilityType: this.newFacilityType,
                    Fatality: this.newFatality,
                    FatalityOther: this.newFatalityOther,
                    FifthIntervention: this.newFifthIntervention,
                    FirstAid: this.newFirstAid,
                    FirstIntervention: this.newFirstIntervention,
                    FloorRestraint: this.newFloorRestraint,
                    Found: this.newFound,
                    FourthIntervention: this.newFourthIntervention,
                    Genitals: this.newGenitals,
                    Guardian: this.newGuardian,
                    GuardianNotified: this.newGuardianNotified,
                    Head: this.newHead,
                    Hospice: this.newHospice,
                    Hospital: this.hospital,
                    HospitalDate: DateTimeUtil.toUTCISOString(this.newHospitalDate),
                    HospitalName: this.newHospitalName,
                    HumanRights: this.humanRights,
                    IncidentCategory: this.newIncidentCategory,
                    IncidentDateTime: DateTimeUtil.toUTCISOString(this.newIncidentDateTime),
                    IncidentDescription: this.newIncidentDescription,
                    IncidentDiscovered: DateTimeUtil.toUTCISOString(this.newIncidentDiscovered),
                    IncidentLocation: this.newIncidentLocation,
                    IncidentLocationType: this.newIncidentLocationType,
                    IncidentType: this.newIncidentType,
                    IncidentVideo: this.newIncidentVideo,
                    InjuredOther: this.newInjuredOther,
                    InjuryRole: this.newInjuryRole,
                    InterventionCause: this.newInterventionCause,
                    InterventionCircumstances: this.newInterventionCircumstances,
                    InterventionDate: DateTimeUtil.toUTCISOString(this.newInterventionDate),
                    InterventionDuration: this.newInterventionDuration,
                    InterventionJustification: this.newInterventionJustification,
                    InterventionPlan: this.newInterventionPlan,
                    InterventionUsed: this.newInterventionUsed,
                    Involuntary: this.newInvoluntary,
                    Involved: this.newInvolved,
                    Involvement1: this.newInvolvement1,
                    Involvement2: this.newInvolvement2,
                    Involvement3: this.newInvolvement3,
                    LastLocation: this.newLastLocation,
                    LastSeen: this.newLastSeen,
                    Law: this.newLaw,
                    LawEnforcement: this.lawEnforcement,
                    LeftAnkle: this.newLeftAnkle,
                    LeftArm: this.newLeftArm,
                    LeftFoot: this.newLeftFoot,
                    LeftHand: this.newLeftHand,
                    LeftHip: this.newLeftHip,
                    LeftKnee: this.newLeftKnee,
                    LeftLeg: this.newLeftLeg,
                    LeftShoulder: this.newLeftShoulder,
                    LeftWrist: this.newLeftWrist,
                    LivingStatus: this.newLivingStatus,
                    Location: this.newLocation,
                    ManagerSignature: this.newManagerSignature,
                    ManagerSigned: this.managerSignature,
                    MedicalCare: this.medicalCare,
                    MedicalClinic: this.newMedicalClinic,
                    MedicationError: this.newMedicationError,
                    MedicationErrOther: this.newMedicationErrOther,
                    MedicationInvolved: this.newMedicationInvolved,
                    MultiplePerson: this.newMultiplePerson,
                    Neck: this.newNeck,
                    NotificationSubmitted: this.newNotificationSubmitted,
                    Notified: this.newNotified,
                    NurseContacted: this.newNurseContacted,
                    OLReport: DateTimeUtil.toUTCISOString(this.newOLReport),
                    OnePerson: this.newOnePerson,
                    Organization1: this.newOrganization1,
                    OrgCaseNum1: this.newOrgCaseNum1,
                    OrgFullName1: this.newOrgFullName1,
                    OrgNotDate1: DateTimeUtil.toUTCISOString(this.newOrgNotDate1),
                    OrgPhone1: this.newOrgPhone1,
                    OrgTitle1: this.newOrgTitle1,
                    OrgType1: this.newOrgType1,
                    OtherHospital: this.newOtherHospital,
                    OtherLaw: this.newLawOther,
                    OtherMedical: this.newOtherMedical,
                    Outcome: this.newOutcome,
                    Pelvis: this.newPelvis,
                    PersonInvolved1: this.newPersonInvolved1,
                    PersonInvolved2: this.newPersonInvolved2,
                    PersonInvolved3: this.newPersonInvolved3,
                    Phone1: this.newPhone1,
                    Phone2: this.newPhone2,
                    Phone3: this.newPhone3,
                    Poison: this.newPoison,
                    Program: this.newProgram,
                    PropertyAction: this.newPropertyAction,
                    PropertyOwner: this.newPropertyOwner,
                    ProtectiveNotified: this.newProtectiveNotified,
                    ReportReceived: DateTimeUtil.toUTCISOString(this.newReportReceived),
                    ReportSignature: this.newReportSignature,
                    ReportSigned: this.staffSignatureNotified,
                    ReportSubmitted: this.newReportSubmitted,
                    ReportSubmittedDate: DateTimeUtil.toUTCISOString(this.newReportSubmittedDate),
                    Restriction: this.restriction,
                    ReviewedDSPDSignature: this.newReviewedDSPDSignature,
                    ReviewedSignature: this.newReviewedSignature,
                    ReviewedSigned: this.reviewedSignature,
                    RightAnkle: this.newRightAnkle,
                    RightArm: this.newRightArm,
                    RightFoot: this.newRightFoot,
                    RightHand: this.newRightHand,
                    RightHip: this.newRightHip,
                    RightKnee: this.newRightKnee,
                    RightShoulder: this.newRightShoulder,
                    RightWrist: this.newRightWrist,
                    Roles1: this.newRoles1,
                    Roles2: this.newRoles2,
                    Roles3: this.newRoles3,
                    SecondIntervention: this.newSecondIntervention,
                    SeizureDescription: this.newSeizureDescription,
                    SeizureDiagnosis: this.newSeizureDiagnosis,
                    SeizureDuration: this.newSeizureDuration,
                    SeizureStart: this.newSeizureStart,
                    SelfInflicted: this.newSelfInflicted,
                    StaffAssessment: this.newStaffAssessment,
                    StaffPhone: this.newStaffPhone,
                    StaffSignature: this.newStaffSignature,
                    StaffSignatureNotification: this.staffSignatureNotification,
                    StaffSigned: this.staffSignature,
                    State: this.newState,
                    Strategy: this.strategy,
                    Street: this.newStreet,
                    SubAlcohol: this.newSubAlcohol,
                    SubDrugs: this.newSubDrugs,
                    SubMedications: this.newSubMedications,
                    SubmittedDSPDSignature: this.newSubmittedDSPDSignature,
                    SubOther: this.newSubOther,
                    SubPrescriptions: this.newSubPrescriptions,
                    SuicideActions: this.newSuicideActions,
                    SuicideDescription: this.newSuicideDescription,
                    SuicideType: this.newSuicideType,
                    SupervisorName: this.newSupervisorName,
                    SupervisorPhone: this.newSupervisorPhone,
                    SupervisorSignature: this.newSupervisorSignature,
                    SupervisorSigned: this.supervisorSignature,
                    SupportCoordinator: this.newSupportCoordinator,
                    SupportCoordinatorNotified: this.newSupportCoordinatorNotified,
                    SupportStrategy: this.supportStrategy,
                    Suspicious: this.newSuspicious,
                    ThirdIntervention: this.newThirdIntervention,
                    Title1: this.newTitle1,
                    Title2: this.newTitle2,
                    Title3: this.newTitle3,
                    TodaysDate: DateTimeUtil.toUTCISOString(this.newTodaysDate),
                    TransportRestraint: this.newTransportRestraint,
                    TwoPerson: this.newTwoPerson,
                    Type: this.newType,
                    Unexpected: this.newUnexpected,
                    Unexplained: this.newUnexplained,
                    ZipCode: this.newZipCode,
                };
                const updateIncidentUrl = `${url}/incidents/${this.incidentID}`;
                this.showLoadingUpdateDialog();

                axios.put(updateIncidentUrl, payload)
                    .then(async () => {
                        if (this.uploadFile !== null && this.uploadFile !== undefined && this.uploadFile.length) {
                            await this.uploadIncidentDocuments();
                        }

                        if (this.damagedPhotos && this.damagedPhotos.length) {
                            await this.uploadDamagedPhotos(this.damagedPhotos);
                        }

                        if (this.incidentVideos && this.incidentVideos.length) {
                            await this.uploadIncidentVideos(this.incidentVideos);
                        }

                        this.showSuccessUpdateDialog();
                        this.clearFieldsAndBack();
                    });
            } else {
                this.msg = true;
                this.text = "Please fill up all required fields";
            }
        },

        initializeFormData(item) {
            // Set for viewing incident's damaged photos
            this.selectedIncidentReport = item;
            this.clientID = item.ClientID;
            this.selectedIncidentReport.DamagedPhotos = item.DamagedPhoto ? item.DamagedPhoto.split(',') : [];
            this.selectedIncidentReport.IncidentVideos = item.IncidentVideo ? item.IncidentVideo.split(',') : [];
            this.titleForm = "Viewing Incident";
            this.newType = item.Type;
            this.newIncidentDateTime = DateTimeUtil.toLocalDateTime(item.IncidentDateTime, 'yyyy-LL-dd HH:mm');
            this.newTodaysDate = DateTimeUtil.toLocalDate(item.TodaysDate);
            this.newIncidentDiscovered = DateTimeUtil.toLocalDateTime(item.IncidentDiscovered, 'yyyy-LL-dd HH:mm');
            this.newProgram = item.Program;
            this.newIncidentLocation = item.IncidentLocation;
            this.newStreet = item.Street;
            this.newCity = item.City;
            this.newState = item.State;
            this.newZipCode = item.ZipCode;
            this.newIncidentLocationType = item.IncidentLocationType;
            this.newPersonInvolved1 = item.PersonInvolved1;
            this.newTitle1 = item.Title1;
            this.newPhone1 = item.Phone1;
            this.newRoles1 = item.Roles1;
            this.newInvolvement1 = item.Involvement1;
            this.newPersonInvolved2 = item.PersonInvolved2;
            this.newTitle2 = item.Title2;
            this.newPhone2 = item.Phone2;
            this.newRoles2 = item.Roles2;
            this.newInvolvement2 = item.Involvement2;
            this.newPersonInvolved3 = item.PersonInvolved3;
            this.newTitle3 = item.Title3;
            this.newPhone3 = item.Phone3;
            this.newRoles3 = item.Roles3;
            this.newInvolvement3 = item.Involvement3;
            this.newOrganization1 = item.Organization1;
            this.newOrgPhone1 = item.OrgPhone1;
            this.newOrgType1 = item.OrgType1;
            this.newOrgFullName1 = item.OrgFullName1;
            this.newOrgTitle1 = item.OrgTitle1;
            this.newOrgNotDate1 = DateTimeUtil.toLocalDate(item.OrgNotDate1);
            this.newOrgCaseNum1 = item.OrgCaseNum1;
            this.hospital = item.Hospital;
            this.newHospitalName = item.HospitalName;
            this.newHospitalDate = DateTimeUtil.toLocalDateTime(item.HospitalDate, 'yyyy-LL-dd HH:mm');
            this.newFacilityType = item.FacilityType;
            this.newOtherHospital = item.OtherHospital;
            this.lawEnforcement = item.LawEnforcement;
            this.newLaw = item.Law;
            this.newLawOther = item.OtherLaw;
            this.medicalCare = item.MedicalCare;
            this.new911Call = item.Call;
            this.newMedicalClinic = item.MedicalClinic;
            this.newER = item.ER;
            this.newAssessedClient = item.AssessedClient;
            this.newFirstAid = item.FirstAid;
            this.newPoison = item.Poison;
            this.newNurseContacted = item.NurseContacted;
            this.newOtherMedical = item.OtherMedical;
            this.newInvolved = item.Involved;
            this.newIncidentCategory = item.IncidentCategory;
            this.newAbuseCategory = item.AbuseCategory;
            this.newAbuseType = item.AbuseType;
            this.newClientRole = item.ClientRole;
            this.newProtectiveNotified = item.ProtectiveNotified;
            this.newChokingType = item.ChokingType;
            this.newChokedItem = item.ChokedItem;
            this.newChokingActions = item.ChokingActions;
            this.newInterventionCircumstances = item.InterventionCircumstances;
            this.newInterventionJustification = item.InterventionJustification;
            this.newInterventionCause = item.InterventionCause;
            this.newInterventionDate = DateTimeUtil.toLocalDateTime(item.InterventionDate, 'yyyy-LL-dd HH:mm');
            this.newInterventionDuration = item.InterventionDuration;
            this.newFirstIntervention = item.FirstIntervention;
            this.newSecondIntervention = item.SecondIntervention;
            this.newThirdIntervention = item.ThirdIntervention;
            this.newFourthIntervention = item.FourthIntervention;
            this.newFifthIntervention = item.FifthIntervention;
            this.newAdditionalRestraints = item.AdditionalRestraints;
            this.newAdditionalMinutes = item.AdditionalMinutes;
            this.newInterventionUsed = item.InterventionUsed;
            this.newOnePerson = item.OnePerson;
            this.newTwoPerson = item.TwoPerson;
            this.newMultiplePerson = item.MultiplePerson;
            this.newFloorRestraint = item.FloorRestraint;
            this.newTransportRestraint = item.TransportRestraint;
            this.newInterventionPlan = item.InterventionPlan;
            this.newBehaviorSpecialist = item.BehaviorSpecialist;
            this.newEnvironment = item.Environment;
            this.newLocation = item.Location;
            this.newSubAlcohol = item.SubAlcohol;
            this.newSubDrugs = item.SubDrugs;
            this.newMedications = item.SubMedications;
            this.newSubPrescriptions = item.SubPrescriptions;
            this.newSubOther = item.SubOther;
            this.newFatality = item.Fatality;
            this.newUnexpected = item.Unexpected;
            this.newHospice = item.Hospice;
            this.newFatalityOther = item.FatalityOther;
            this.newAbdomen = item.Abdomen;
            this.newBack = item.Back;
            this.newButtocks = item.Buttocks;
            this.newChest = item.Chest;
            this.newFace = item.Face;
            this.newGenitals = item.Genitals;
            this.newHead = item.Head;
            this.newNeck = item.Neck;
            this.newPelvis = item.Pelvis;
            this.newLeftAnkle = item.LeftAnkle;
            this.newLeftArm = item.LeftArm;
            this.newLeftFoot = item.LeftFoot;
            this.newLeftHand = item.LeftHand;
            this.newLeftKnee = item.LeftKnee;
            this.newLeftLeg = item.LeftLeg;
            this.newLeftShoulder = item.LeftShoulder;
            this.newLeftWrist = item.LeftWrist;
            this.newLeftHip = item.LeftHip;
            this.newRightAnkle = item.RightAnkle;
            this.newRightArm = item.RightArm;
            this.newRightFoot = item.RightFoot;
            this.newRightHand = item.RightHand;
            this.newRightKnee = item.RightKnee;
            this.newRightShoulder = item.RightShoulder;
            this.newRightWrist = item.RightWrist;
            this.newRightHip = item.RightHip;
            this.newInjuredOther = item.InjuredOther;
            this.newInjuryRole = item.InjuryRole;
            this.newSelfInflicted = item.SelfInflicted;
            this.newMedicationInvolved = item.MedicationInvolved;
            this.newMedicationError = item.MedicationError;
            this.newAdverseReaction = item.AdverseReaction;
            this.newAdverseDescription = item.AdverseDescription;
            this.newMedicationErrOther = item.MedicationErrOther;
            this.newLastSeen = item.LastSeen;
            this.newLastLocation = item.LastLocation;
            this.newDiscovered = item.Discovered;
            this.newUnexplained = item.Unexplained;
            this.newInvoluntary = item.Involuntary;
            this.newSuspicious = item.Suspicious;
            this.newFound = item.Found;
            this.newLivingStatus = item.LivingStatus;
            this.newDamagedItem = item.DamagedItem;
            this.newDamagedPhoto = item.DamagedPhoto;
            this.newIncidentVideo = item.IncidentVideo;
            this.newPropertyOwner = item.PropertyOwner;
            this.newPropertyAction = item.PropertyAction;
            this.newSeizureDescription = item.SeizureDescription;
            this.newSeizureDiagnosis = item.SeizureDiagnosis;
            this.newSeizureStart = item.SeizureStart;
            this.newSeizureDuration = item.SeizureDuration;
            this.newSuicideType = item.SuicideType;
            this.newSuicideDescription = item.SuicideDescription;
            this.newSuicideActions = item.SuicideActions;
            this.newDetailsOther = item.DetailsOther;
            this.newCircumstances = item.Circumstances;
            this.newNotified = item.Notified;
            this.newIncidentType = item.IncidentType;
            this.newIncidentDescription = item.IncidentDescription;
            this.newOutcome = item.Outcome;
            this.newStaffAssessment = item.StaffAssessment;
            this.newStaffSignature = item.StaffSignature;
            // this.staffSignature = !!this.newStaffSignature;
            this.staffSignature = item.StaffSigned;
            this.newStaffPhone = item.StaffPhone;
            this.supervisorSignature = item.SupervisorSigned;
            this.newSupervisorName = item.SupervisorName;
            this.newSupervisorPhone = item.SupervisorPhone;
            this.newManagerSignature = item.ManagerSignature || "";
            // this.managerSignature = !!this.newManagerSignature;
            this.managerSignature = item.ManagerSigned;
            this.newSupportCoordinator = item.SupportCoordinator;
            this.newSupportCoordinatorNotified = item.SupportCoordinatorNotified;
            this.newGuardian = item.Guardian;
            this.newGuardianNotified = item.GuardianNotified;
            this.newSupervisorPhone = item.SupervisorPhone;
            this.newSupervisorSignature = item.SupervisorSignature || "";
            this.supervisorSignature = !!this.newSupervisorSignature;
            this.newReportReceived = DateTimeUtil.toLocalDateTime(item.ReportReceived, 'yyyy-LL-dd HH:mm');
            this.reviewedSignature = item.ReviewedSigned;
            this.newReviewedSignature = item.ReviewedSignature;
            this.newAdminTitle = item.AdminTitle;
            this.newNotificationSubmitted = item.NotificationSubmitted;
            this.newReportSubmitted = item.ReportSubmitted;
            this.newReportSubmittedDate = DateTimeUtil.toLocalDateTime(item.ReportSubmittedDate, 'yyyy-LL-dd HH:mm');
            this.newReportSigned = item.ReportSigned;
            this.newReportSignature = item.ReportSignature;
            this.staffSignatureNotified = item.ReportSigned;
            this.newAdministrativeNotes = item.AdministrativeNotes;
            this.humanRights = item.HumanRights;
            this.supportStrategy = item.SupportStrategy;
            this.newOLReport = DateTimeUtil.toLocalDateTime(item.OLReport, 'yyyy-LL-dd HH:mm');
            this.restriction = item.Restriction;
            this.strategy = item.Strategy;
            this.incidentID = item._id;
            this.reviewedDSPDSignature = item.ReviewedDSPDSignature;
            this.newReviewedDSPDSignature = item.ReviewedDSPDSignature;
            this.submittedDSPDSignature = item.SubmittedDSPDSignature ? true : false;
            this.newSubmittedDSPDSignature = item.SubmittedDSPDSignature;
            let documents = [];

            if (item.Document) {
                documents = item.Document && item.Document.length ? item.Document : [item.Document];
            }

            if (documents) {
                this.newDocument = documents.map(document => {
                    return {
                        name: document.Name,
                        url: document.AWSLink,
                        type: document.AWSLink?.split('.').pop()
                    };
                });
            }

            if (item.ReviewedSignature !== "" || null) {
                this.reviewedSignature = true;
                this.newReviewedSignature = item.ReviewedSignature;
            } else {
                this.reviewedSignature = false;

            }

            this.getClient();
            this.getRights();
            this.getSupportStrategies();
            this.getUnits();
        },


        addSignature() {
            if (!this.newSupervisorSignature) {
                this.supervisorSignature = true;
                this.newSupervisorSignature = this.staff + " - " + new Date();
            } else {
                this.newSupervisorSignature = ""
                this.supervisorSignature = false;
            }
        },

        addStaffSignature() {
            if (!this.newStaffSignature) {
                this.staffSignature = true;
                this.newStaffSignature = this.staff + " - " + new Date();
            } else {
                this.newStaffSignature = ""
                this.staffSignature = false;
            }

        },

        addStaffSignatureNotification() {
            if (!this.newReportSignature) {
                this.staffSignatureNotified = true;
                this.newReportSignature = this.staff + " - " + new Date();
            } else {
                this.newReportSignature = ""
                this.staffSignatureNotified = false;
            }

        },

        addDSPDReviewedSignature() {
            if (!this.newDSPDReviewedSignature) {
                this.reviewedDSPDSignature = true;
                this.newReviewedDSPDSignature = this.staff + " - " + this.staffRole + " - " + new Date();
            } else {
                this.newDSPDReviewedSignature = ""
                this.reviewedDSPDSignature = false;
            }
        },

        addDSPDSubmittedSignature() {
            if (!this.newSubmittedDSPDSignature) {
                this.submittedDSPDSignature = true;
                this.newSubmittedDSPDSignature = this.staff + " - " + this.staffRole + " - " + new Date();
            } else {
                this.newSubmittedDSPDSignature = ""
                this.submittedDSPDSignature = false;
            }
        },

        addManagerSignature() {
            if (!this.newManagerSignature) {
                this.managerSignature = true;
                this.newManagerSignature = this.staff + " - " + new Date();
            } else {
                this.newManagerSignature = ""
                this.managerSignature = false;
            }
        },

        addReviewedSignature() {
            if (!this.newReviewedSignature) {
                this.reviewedSignature = true;
                this.newReviewedSignature = this.staff + " - " + new Date();
            } else {
                this.newReviewedSignature = ""
                this.reviewedSignature = false;
            }
        },

        addReportSignature() {
            if (!this.newReportSignature) {
                this.staffSignatureNotified = true;
                this.newReportSignature = this.staff + " - " + new Date();
            } else {
                this.newReviewedSignature = ""
                this.staffSignatureNotified = false;
            }
        },

        async fileSelected(e) {
            this.uploadFile = await this.renameFileHelper(e, this.clientName, "IncidentReport");
        },

        async uploadIncidentDocuments() {
            try {
                this.msg = true;
                this.text = 'Uploading incident documents';

                const formData = new FormData();

                for (let i = 0; i < this.uploadFile.length; i++) {
                    formData.append('files', this.uploadFile[i]);
                }

                const uploadUrl = `${url}/incidents/fileUploader/${this.incidentID}`;
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };

                await axios.post(uploadUrl, formData, config);
                this.msg = true;
                this.text = 'Incident documents successfully uploaded';
            } catch (e) {
                console.log({e});
            }
        },

        deleteChip(index) {
            // Prompt here with text if required
            this.newDocument.splice(index, 1);
        },

        getSupportStrategies() {
            axios.get(`${url}/support/${this.clientID}`).then((response) => {
                this.strategies = response.data.supports;
            })
        },

        getClient() {
            axios.get(`${url}/clients/${this.clientID}`).then(async (res) => {
                const client = res.data.client[0];
                this.clientName = client.Name;
            });
        },

        clearFields() {
            this.newType = "";
            this.newIncidentDateTime = "";
            this.newTodaysDate = "";
            this.newIncidentDiscovered = "";
            this.newProgram = "";
            this.newIncidentLocation = "";
            this.newStreet = "";
            this.newCity = "";
            this.newState = "";
            this.newZipCode = "";
            this.newIncidentLocationType = "";
            this.newPersonInvolved1 = "";
            this.newTitle1 = "";
            this.newPhone1 = "";
            this.newRoles1 = "";
            this.newInvolvement1 = "";
            this.newPersonInvolved2 = "";
            this.newTitle2 = "";
            this.newPhone2 = "";
            this.newRoles2 = "";
            this.newInvolvement2 = "";
            this.newPersonInvolved3 = "";
            this.newTitle3 = "";
            this.newPhone3 = "";
            this.newRoles3 = "";
            this.newInvolvement3 = "";
            this.newOrganization1 = "";
            this.newOrgPhone1 = "";
            this.newOrgType1 = "";
            this.newOrgFullName1 = "";
            this.newOrgTitle1 = "";
            this.newOrgNotDate1 = "";
            this.newOrgCaseNum1 = "";
            this.hospital = false;
            this.newHospitalName = "";
            this.newHospitalDate = null;
            this.newFacilityType = "";
            this.newOtherHospital = "";
            this.lawEnforcement = false;
            this.newLaw = "";
            this.newLawOther = "";
            this.medicalCare = false;
            this.new911Call = "";
            this.newMedicalClinic = "";
            this.newER = "";
            this.newAssessedClient = "";
            this.newFirstAid = "";
            this.newPoison = "";
            this.newNurseContacted = "";
            this.newOtherMedical = "";
            this.newInvolved = "";
            this.newCircumstances = "";
            this.newAbuseCategory = "";
            this.newAbuseType = "";
            this.newClientRole = "";
            this.newProtectiveNotified = "";
            this.newChokingType = "";
            this.newChokedItem = "";
            this.newChokingActions = "";
            this.newInterventionCircumstances = "";
            this.newInterventionJustification = "";
            this.newInterventionCause = "";
            this.newInterventionDate = "";
            this.newInterventionDuration = "";
            this.newFirstIntervention = "";
            this.newSecondIntervention = "";
            this.newThirdIntervention = "";
            this.newFourthIntervention = "";
            this.newFifthIntervention = "";
            this.newAdditionalRestraints = "";
            this.newInterventionUsed = "";
            this.newOnePerson = "";
            this.newTwoPerson = "";
            this.newMultiplePerson = "";
            this.newFloorRestraint = "";
            this.newTransportRestraint = "";
            this.newInterventionPlan = "";
            this.newBehaviorSpecialist = "";
            this.newEnvironment = "";
            this.newEvacuated = "";
            this.newLocation = "";
            this.newSubAlcohol = "";
            this.newSubDrugs = "";
            this.newSubMedications = "";
            this.newSubPrescriptions = "";
            this.newSubOther = "";
            this.newFatality = "";
            this.newUnexpected = "";
            this.newHospice = "";
            this.newFatalityOther = "";
            this.newAbdomen = "";
            this.newBack = "";
            this.newButtocks = "";
            this.newChest = "";
            this.newFace = "";
            this.newGenitals = "";
            this.newHead = "";
            this.newNeck = "";
            this.newPelvis = "";
            this.newLeftAnkle = "";
            this.newLeftArm = "";
            this.newLeftFoot = "";
            this.newLeftHand = "";
            this.newLeftKnee = "";
            this.newLeftLeg = "";
            this.newLeftShoulder = "";
            this.newLeftWrist = "";
            this.newLeftHip = "";
            this.newRightAnkle = "";
            this.newRightArm = "";
            this.newRightFoot = "";
            this.newRightHand = "";
            this.newRightKnee = "";
            this.newRightShoulder = "";
            this.newRightWrist = "";
            this.newRightHip = "";
            this.newInjuredOther = "";
            this.newInjuryRole = "";
            this.newSelfInflicted = "";
            this.newMedicationInvolved = "";
            this.newMedicationError = "";
            this.newAdverseReaction = "";
            this.newAdverseDescription = "";
            this.newMedicationErrOther = "";
            this.newLastSeen = "";
            this.newLastLocation = "";
            this.newDiscovered = "";
            this.newUnexplained = "";
            this.newInvoluntary = "";
            this.newSuspicious = "";
            this.newFound = "";
            this.newLivingStatus = "";
            this.newDamagedItem = "";
            this.newDamagedPhoto = "";
            this.newIncidentVideo = "";
            this.newPropertyOwner = "";
            this.newPropertyAction = "";
            this.newSeizureDescription = "";
            this.newSeizureDiagnosis = "";
            this.newSeizureStart = "";
            this.newSeizureDuration = "";
            this.newSuicideType = "";
            this.newSuicideDescription = "";
            this.newSuicideActions = "";
            this.newDetailsOther = "";
            this.newNotified = "";
            this.newIncidentType = "";
            this.newIncidentDescription = "";
            this.newOutcome = "";
            this.newStaffAssessment = "";
            this.newStaffSignature = "";
            this.newStaffPhone = "";
            this.newSupervisorName = "";
            this.newDocument = [];
            this.newSupportCoordinator = "";
            this.newSupportCoordinatorNotified = "";
            this.newGuardian = "";
            this.newGuardianNotified = "";
            this.newSupervisorPhone = "";
            this.newSupervisorSignature = "";
            this.newManagerSignature = "";
            this.newReportReceived = "";
            this.newReviewedSignature = "";
            this.newAdminTitle = "";
            this.newNotificationSubmitted = "";
            this.newReportSubmitted = "";
            this.newReportSubmittedDate = "";
            this.newAdministrativeNotes = "";
            this.humanRights = "";
            this.newOLReport = "";
            this.restriction = null;
            this.reviewedSignature = false;
            this.newDocument = [];
            this.selectedIncidentReport = {};
        },

        getRights: function () {
            this.isLoading = true;
            axios.get(`${url}/rights/${this.clientID}`).then(res => {
                this.rights = res.data.rights;

            })
        },

        getIncident() {
            axios.get(`${url}/incidents/${this.incidentID}`).then(response => {
                this.incident = response.data.incident;
                this.initializeFormData(this.incident);
            }).catch(error => {
                console.error('Error fetching incidents:', error);
            });
        },

        downloadImage(photo) {
            window.location.href = photo;
        },

        clearFieldsAndBack() {
            this.clearFields();

            if (this.$route.query.clientNav === 'false') {
                this.$router.go(-1);
            } else {
                this.$router.push({
                    path: `/incidents/${this.clientID}`
                });
            }
        },

        getFileType(url) {
            const extension = url.split('.').pop();
            return extension ? extension : 'unknown';
        },

        removeImage(index) {
            axios.delete(`${url}/incidents/document/${this.incidentID}/${index}`)
                .then(() => {
                    this.newDocument.splice(index, 1);
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        downloadDocument(url) {

            let documentUrl = url.url

            if (documentUrl) {
                window.open(documentUrl, '_blank');
            } else {
                alert('No documents available');
            }
        }
        ,

        showLoadingAddDialog() {
            Swal.fire({
                title: 'Creating Incident',
                html: 'Please wait...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        }
        ,

        showLoadingUpdateDialog() {
            Swal.fire({
                title: 'Updating Incident',
                html: 'Please wait...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        }
        ,

        showSuccessAddDialog() {
            Swal.fire({
                icon: 'success',
                text: 'A new incident has been added successfully.',
                showConfirmButton: false,
                timer: 3000
            });
        }
        ,

        showSuccessUpdateDialog() {
            Swal.fire({
                icon: 'success',
                text: 'An incident has been updated successfully.',
                showConfirmButton: false,
                timer: 3000
            });
        }
        ,
    }
    ,

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

.btn-filter {
    margin-top: 40px;
    margin-right: 50px;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

@media print {
    #printTable {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;

    }

    #printItem {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;


    }

    .hideOnPrint {
        display: none;
        border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;

    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }
}

</style>
